import React, {useState, useEffect, useRef} from "react";
import { createBranchV2, getBranch, updateBranchInfo, updateBranchLogo } from "../helper/api";
import { isAuthenticated } from "../../../auth";
import { getMemberLoginRegistrationInfo } from "../../member/helper/api";
import { formatDateTime, getUserRole, isValidIP, startLoader, stopLoader } from "../../../lib/utils";
import '../style.scss';
import KioskContent from "../Desktop/KioskContent";
import { City,Country,State }  from 'country-state-city';
import _, { throttle } from "lodash";
import Toast from "../../../lib/toast";
import { getTaxes } from "../../../core/helper/TaxApiCall";
import { getUsersList, getUsersListV2 } from "../../employees/helper/api";
import { getAllGym, getGymCount } from "../../company/helper/api";
import { useHistory } from "react-router-dom";
import { generateAccessKey, deleteAccessKey } from "../helper/api";

const ManageGym = (props) => {

  const history = useHistory();
  const { user, token } = isAuthenticated();
  const [isCompanySpinnerLoader,setCompanySpinnerLoader] = useState(false);
  const [companySearch,setCompanySearch] = useState('')
  const [isButtonLock,setButtonLock] = useState(false);
  const [gymAdmins,setGymAdmins] = useState([]);
  const [branch, setBranch] = useState();
  const [taxList,setTaxList] = useState([]);
  const [companyInfo, setCompanyInfo] = useState("");
  const [companies, setCompanies] = useState([]);
  var [pageNo,setPageNo] = useState({
    company:1
  });
  const pageSize = {
    company:20
  };
  const [pageCount,setPageCount] = useState({
    company:1
  });
  const [total,setTotal] = useState({
    company:0
  })

  const contactInfoList = {
    name: "",
    type: "",
    primaryUser: true,
    contacts: "",
    emailAddress: ""
  }

  const branchId = props.branch._id;
  const [branchMetaData,setBranchMetaData]=useState({kioskRegistrationCount:0,mobileRegisteredCount:0,memberCount:0});
  const [isReloadContent,setReloadContent] = useState(false);
  const [isEditEnabled, setEditEnabled] = useState(false);
  const [editType, setEditType] = useState("gym-details");
  const [currentElementId, setCurrentElementId] = useState("");
  const [isDropdownType, setDropdownType] = useState("");
  const [isAdsViewOpen, setAdsViewOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const companyName=useRef('');

  const [branchInfo, setBranchInfo] = useState({
    name: "",
    gymLogo: "",
    branch: "",
    allowedGender: "",
    gymSize: "",
    establishmentYear: "",
    weekDays: [
      {
        day : "Mon",
        selected : false
      },
      {
        day : "Tue",
        selected : false
      },
      {
        day : "Wed",
        selected : false
      },
      {
        day : "Thu",
        selected : false
      },
      {
        day : "Fri",
        selected : false
      },
      {
        day : "Sat",
        selected : false
      },
      {
        day : "Sun",
        selected : false
      }
    ],
    amenities: [],
    offeredActivities: [],
    gymPooling: false,
    bulkDNDSms: false,
    address: {
      landmark:"",
      streetAddress: "",
      nearestLandmark: "",
      zipCode: "",
      country:"India",
      state: "Maharashtra",
      city: "Pune",
      phoneNumber: ""
    },
    contactInfoList: [],
    gstin: "",
    series: {
      date:new Date(),
      customSeries: false,
      name: "",
      invoiceConstant: "",
      firstNumber: "1"
    },
    includedTax: [],
    renewalPeriod: "",
    smsConfig:{
      senderID: "",
      totalSMSLimit: "",
      usedSMS:"0",
      activeNotifications: []
    },
    whatsAppConfig: {
      activeNotifications: []
    },
    deviceList: []
  });

  const amenities =["Canteen", "Ac", "Wifi", "Group classes","Locker","Steam Bath","Shower","spa","Car Parking","other","Music","Swimming Pool","LOCKERS","musc","Zumba","Changing Room","Two wheeler parking","STEAM","Four wheeler parking","Sunday Open","Protein/projection","lock","bike parking","Strength Training Equipment","Sports Activity","Free Trial","PROFESSIONAL SERVICE","Roof Top Workout","Ice Bath Therapy","4D Massage Chair","Personalized Workout schedule/ Personalized Diet Chart","certified trainers","Sauna","Terrace Workout","stem","show","wifi","Pool Table","Table Tennis","Fat loss","Music And Video Entertainment","Stretching Area","Nutritional Support","Desi Akhada","Basketball Court","Supplement","Cafe","Circuit Training","Hill treaking","A/C","Loker","nonAC steam","digital classroom","practice lab","Others","6Am To 11Pm (17 Hours Non Stop Gym)", "Body composition analysis","Loc","Free trail","Sps","Yoga"];
  const offeredActivities = ["Zumba", "Pilates", "Kick Boxing", "Fitness Workout","Personal Training","Yoga","Power Yoga","Joyride","Cardio","Machine Weight","Free Weight Sessions", "Indo cylcling studio","Folk Fitness", "Circuit Training", "Functional Training", "Magic Plates", "TBT","Fun & Fitness","Abs Burners","Aerobics","Dungal", "Gym Workout","Ride"];

  const deviceActivities = ["Bronze Trainer", "ABS", "Swimming Pool", "Gold Trainer", "Functional Training", "Bollywood Dance", "Joy Ride", "BCA", "Stretching", "Sales Consult", "TBT", "Freelancer"]
  
  const biometricInfo = {
    deviceID: "",
    deviceActivity: "",
    gymSlug: "",
    deviceType: "",
    ipAddress: "",
    serialNumber: ""
  }; 

  const [citySearch, setCitySearch] = useState("");
  const [visibleCount, setVisibleCount] = useState(20); // load first 20
  const branchScrollRef = useRef(null);
  const cityScrollRef = useRef(null);
  const [search,setSearch] = useState('');
  const stateScrollRef = useRef(null);
  const countryScrollRef = useRef(null);
  const [type,setType] = useState("branch");
  const [allItems, setAllItems] = useState([]);
  const [createdGymResponse, setCreatedGymResponse] = useState("");
  const [isUpdateProfile, setUpdateProfile] = useState(false);
  const [accessKey, setAccessKey] = useState("");
  const [accessKeyLoading, setAccessKeyLoading] = useState(false);

  const removeBiometricDevice = (index = -1) => {
    setBranchInfo(oldstate=>{
      if(oldstate.deviceList.length && index>-1){
        oldstate.deviceList.splice(index,1);
      }
      return {...oldstate};
    })
  }

  const handleCompanySearch = event =>{
    setCompanySearch(event.target.value);
  }

  const GetParams = () =>{
    let params = {
      pageNo:pageNo.company,
      pageSize:pageSize.company,
      isFilterByProfile:true
    };
    if(companySearch) params.q = companySearch;
    return params;
  }

  const GetCompanies = async (isReload) =>{
    try{
      let params = GetParams();
      const response = await getAllGym(user._id,token,params);
      if(!response.error){
        setCompanies(isReload?response:[...response,...companies]);
      }
    }catch(error){

    }
  }

  const GetCompaniesCount = async () =>{
    try{
      let params = GetParams();
      const response = await getGymCount(user._id,token,params);
      if(!response.error){
         setPageCount({
          ...pageCount,
          company:Math.ceil(response.COUNT / pageSize.company)
         });
         pageNo.company = 1
         setPageNo({
          ...pageNo
         });
         setTotal({
          ...total,
          company:response.COUNT
         })

      }
    }catch(error){

    }
  }

  const GetAdmins = async () =>{
    try{
      const params = {
        branchIDs:[branchId],
        roles:[5],
        noLimit:'noLimit'
      }

      let response = await getUsersListV2(user._id,token,params);
      if(response.error){

      }else{
        setGymAdmins(response);
      }

    }catch(error){

    }
  }
 

  const removeContactInfo = event => index =>{
     setBranchInfo(prev=>{
      if(prev.contactInfoList.length) prev.contactInfoList.splice(index,1);

      return {
        ...prev
      }
    }) 
  }


  const addNewContactInfo=event=>{
    setBranchInfo(prev=>{
      prev.contactInfoList.push(contactInfoList);

      return {
        ...prev
      }
    })
  }

  const CreateBranch = async event =>{
    try{

      await startLoader();
      setButtonLock(true);

      const payload = {
        name:branchInfo.name,
        branch:branchInfo.branch,
        allowedGender:branchInfo.allowedGender,
        gymSize:branchInfo.gymSize,
        establishmentYear:branchInfo.establishmentYear,
        weekDays:branchInfo.weekDays.filter(d=>d.selected).map(d=>d.day),
        amenities:branchInfo.amenities,
        address:branchInfo.address.streetAddress,
        nearest_landmark:branchInfo.address.nearestLandmark,
        landmark:branchInfo.address.landmark,
        zipcode:branchInfo.address.zipCode,
        country:branchInfo.address.country,
        state:branchInfo.address.state,
        city:branchInfo.address.city,
        phone:branchInfo.address.phoneNumber,
        branchconfig:{
          isGymPooling:branchInfo.gymPooling,
          gstIn:branchInfo.gstin,
          isBulkSmsToDndNumber:branchInfo.bulkDNDSms,
          smsConfig:{...branchInfo.smsConfig},
          whatsAppConfig:{...branchInfo.whatsAppConfig},
          renewalPeriod:branchInfo.renewalPeriod,
          taxIDs:branchInfo.includedTax
        },
        series:{
          ...branchInfo.series
        },
        // contactInfoList:branchInfo.contactInfoList.filter(d=>d.name && d.contacts),
        deviceList:branchInfo.deviceList.map(d=>({deviceActivities:[d.deviceActivity],...d})),
        activities:branchInfo.offeredActivities,
      };

      if(companyInfo?._id && companyInfo?.name && `${companyInfo.name}`.trim().toLowerCase() == `${companyName.current}`.trim().toLowerCase()){
        payload.companyId = companyInfo._id;
      }else{
        payload.companyName = companyName.current || branchInfo.name;
      }

      const response = await createBranchV2(user._id,token,payload);

      if(response.error){
        new Toast({
          type:"error",
          duration:3000,
          message:response.error
        })
        return;
      }
      
      setCreatedGymResponse(response);

      new Toast({
        type:"success",
        duration:3000,
        message:"Branch created successfully"
      })
      
      // if(window.location.pathname = "/gyms") history.push('/gyms');

      props.toggleAddBranchModal();

    }catch(error){
      new Toast({
        type:"error",
        duration:3000,
        message:error
      })
    }
    setButtonLock(false);
    await stopLoader()
  }

  const updateLogo = async(branchId) => {
    if (branchInfo.gymLogo) {
      let formData = new FormData();
      formData.append("branchId", branchId);
      formData.append("photo", branchInfo.gymLogo);

      const response = await updateBranchLogo(user._id, token, formData);

      if(response.error){
        new Toast({
          type:"error",
          duration:3000,
          message:"Couldn't Update Gym Logo"
        })
      }else{
        new Toast({
          type:"success",
          duration:3000,
          message:"Gym Logo Updated"
        })
      }
    }
  }

  useEffect(() => {

    if(createdGymResponse.branchId){
      updateLogo(createdGymResponse.branchId);
    }
    

    if(isUpdateProfile){
      updateLogo(props.branch._id);
    }

  },[createdGymResponse.branchId || isUpdateProfile]);

  const UpdateBranchInfo = async event =>{
    try{

      await startLoader();
      setButtonLock(true);
      const payload = {
        name:branchInfo.name,
        branch:branchInfo.branch,
        allowedGender:branchInfo.allowedGender,
        gymSize:branchInfo.gymSize,
        establishmentYear:branchInfo.establishmentYear,
        weekDays:branchInfo.weekDays.filter(d=>d.selected).map(d=>d.day),
        amenities:branchInfo.amenities,
        address:branchInfo.address.streetAddress,
        nearest_landmark:branchInfo.address.nearestLandmark,
        landmark:branchInfo.address.landmark,
        zipcode:branchInfo.address.zipCode,
        country:branchInfo.address.country,
        state:branchInfo.address.state,
        city:branchInfo.address.city,
        phone:branchInfo.address.phoneNumber,
        branchconfig:{
          isGymPooling:branchInfo.gymPooling,
          gstIn:branchInfo.gstin,
          isBulkSmsToDndNumber:branchInfo.bulkDNDSms,
          smsConfig:{...branchInfo.smsConfig},
          whatsAppConfig:{...branchInfo.whatsAppConfig},
          renewalPeriod:branchInfo.renewalPeriod,
          taxIDs:branchInfo.includedTax
        },
        series:{
          ...branchInfo.series
        },
        contactInfoList:branchInfo.contactInfoList.filter(d=>d.name && d.contacts),
        deviceList:branchInfo.deviceList.map(d=>({deviceActivities:[d.deviceActivity],...d})),
        activities:branchInfo.offeredActivities,
      };


      const response = await updateBranchInfo(user._id,token,branchId,payload);

      if(response.error){
        new Toast({
          type:"error",
          duration:3000,
          message:response.error
        })

        return;
      }
      
      if(branchInfo.gymLogo){
        setUpdateProfile(true);
      }else{
        setUpdateProfile(false);
      }

      new Toast({
        type:"success",
        duration:3000,
        message:"Branch updated successfully"
      })
      
      // props.handleReloadGyms();
      
      props.toggleAddBranchModal();

    
      // if(window.location.pathname = "/gyms") history.push('/gyms')


    }catch(error){
      new Toast({
        type:"error",
        duration:3000,
        message:error
      })
    }

    setButtonLock(false);
    await stopLoader();
  }


  const handleSearch = event =>{
    setSearch(event.target.value);
  }

 
  const getCountries = async () => {
    const res = await fetch("https://countriesnow.space/api/v0.1/countries");
    const data = await res.json();
    return data.data;
  };

  const getStates = async (countryName) => {
    const res = await fetch(
      "https://countriesnow.space/api/v0.1/countries/states",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ country: countryName })
      }
    );
    const data = await res.json();
    return data.data.states;
  };

  const getCities = async (countryName, stateName) => {
    // alert(JSON.stringify({
    //     country:branchInfo.address.country, // "India"
    //     state:branchInfo.address.state    // "Maharashtra"
    // }))
    const res = await fetch(
      "https://countriesnow.space/api/v0.1/countries/state/cities",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ country: countryName, state: stateName })
      }
    );
    const data = await res.json();
    return data.data;
  };

  const getAllCitiesOfCountry = async (country) => {
  const res = await fetch(
    "https://countriesnow.space/api/v0.1/countries/cities",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ country })
    }
  );

  const data = await res.json();
  return data.data; // ["Mumbai", "Delhi", "Bangalore", ...]
};

 

const getLocationList = async (type) => {

  switch (type) {
    case "country":
      return ["India"];

    case "branch":
      return await getAllCitiesOfCountry(
        branchInfo.address.country // "India"
      );

    case "state": {
      const states = await getStates(branchInfo.address.country);
      return states.map(s => s.name);
    }

    case "city":
      return await getCities(
        branchInfo.address.country,
        branchInfo.address.state
      );

    default:
      return [];
  }
};

const handleSelectCompany = (selectedCompany) => {
  setCompanyInfo(selectedCompany);
  if(document.getElementById("company")) document.getElementById("company").value = selectedCompany.name;
  companyName.current = selectedCompany?.name || '';
}


useEffect(() => {
  let isMounted = true;

  setLoading(true);
  getLocationList(type).then(data => {
    if (isMounted) {
      setAllItems(data);
      setLoading(false);
    }
  });

  return () => {
    isMounted = false;
  };
}, [type]);

const filteredItems = allItems.filter(item => {
  const value =
    typeof item === "string"
      ? item
      : item?.name || item?.city || "";

  return value.toLowerCase().includes(search.toLowerCase());
});

const displayedItems = filteredItems.slice(0, visibleCount);




  const handleScroll = event => {
    const element = event.target;
    if (!element) return;
    if (element.scrollTop + element.clientHeight >= element.scrollHeight - 50) {
      setVisibleCount(prev => Math.min(prev + 20, filteredItems.length));
    }
  };


  const handleSelectTax = taxId =>event =>{
    setBranchInfo(prev=>{
      if(prev.includedTax.indexOf(taxId) == -1) prev.includedTax.push(taxId);
      else prev.includedTax.splice(taxId,1);
      return {...prev};
    })
  }


  const getSelectedBranch = async() => {
    try {
      let response = await getBranch(user._id, token, branchId);
      if (response?.error) {
        
      } else {
        if(response){
          if(response.branch && document.getElementById("branch")) document.getElementById("branch").value = response.branch;
          if(response.city && document.getElementById("city")) document.getElementById("city").value = response.city;
          if(response.state && document.getElementById("state")) document.getElementById("state").value = response.state;
          if(response.country && document.getElementById("country")) document.getElementById("country").value = response.country;

          setCompanyInfo(response?.gym?.[0]?response?.gym[0]:'')
          if(document.getElementById("company") && !document.getElementById("company").value) document.getElementById("company").value =  response?.gym[0]?.name || '';
          if(!companyName.current) companyName.current = response?.gym[0]?.name || '';

          setBranchInfo(prev=>{
            prev.name = response.name;
            prev.weekDays = prev.weekDays.map(d=>({
              ...d,
              selected:(response.weekDays || []).indexOf(d.day) != -1
            }));
            prev.includedTax = response?.branchconfig?.[0]?.taxIDs || [];
            prev.address = {
              ...prev.address,
              streetAddress:response.address || '',
              nearestLandmark:response.nearest_landmark || '',
              landmark:response.landmark || '',
              state:response.state || '',
              city:response.city || '',
              country: response.country || '',
              zipCode:response.zipcode || '',
              phoneNumber:response.phone || ''
            };
            prev.contactInfoList=(response.branchcontactinfos || []).map(d=>({
              ...contactInfoList,
              name: d.name,
              type: d.type,
              primaryUser: d.isPrimaryUser?true:false,
              contacts: d?.phone?.phoneNumber || '',
              emailAddress: d.email || ''
            }))
            prev.smsConfig={
              ...prev.smsConfig,
              senderID:response?.branchconfig?.[0]?.smsConfig?.smsSenderId || '',
              totalSMSLimit:response?.branchconfig?.[0]?.smsConfig?.smsLimit || '',
              usedSMS:response?.branchconfig?.[0]?.smsConfig?.usedSmsLimit || '0',
              activeNotifications:response?.branchconfig?.[0]?.smsConfig?.activeNotifications || [] 
            }
            prev.whatsAppConfig={
              ...prev.whatsAppConfig,
              activeNotifications: response?.branchconfig?.[0]?.whatsAppConfig?.activeNotifications || []
            }
            prev.series = {
              ...prev.series,
              name:response?.series?.[0]?.name || '',
              date:response?.series?.[0]?.date || '',
              invoiceConstant: `${response?.series?.[0]?.prefix?response?.series?.[0]?.prefix+"/":''}`+response?.series?.[0]?.value || '',
              firstNumber:response?.series?.[0]?.first_number || '1',
              customSeries:!response?.series?.[0]?.isDefaultSeries?true:false
            }
            prev.deviceList = (response?.biometricdevices || []).map(device=>({
              ...biometricInfo,
              name:device.name || '',
              ipAddress:device.ip || '',
              serialNumber:device.serialNumber || '',
              vendor:device.vendor || '',
              deviceType:device.deviceType || '',
              deviceActivity:device.deviceActivities?.[0] || ''
            }));
            prev.renewalPeriod = response?.branchconfig?.[0]?.renewalPeriod || '';
            setAccessKey(response.accessKey || "");
            prev.amenities = response.amenities || [];
            prev.offeredActivities = response.activities || [];
            prev.bulkDNDSms = response.bulkDNDSms?true:false;
            prev.branch = response.branch?response.branch:"";
            prev.allowedGender=response.allowedGender?response.allowedGender:"";
            prev.bulkDNDSms = response.bulkDNDSms?response.bulkDNDSms:false;
            prev.establishmentYear = response.establishmentYear?response.establishmentYear:"";
            prev.gstin = (response.branchconfig && response.branchconfig.length && response.branchconfig[0].gstIn)?response.branchconfig[0].gstIn:"";
            prev.gymPooling = (response.branchconfig && response.branchconfig.length && response.branchconfig[0].isGymPooling) ? true:false;
            prev.gymSize = response.gymSize?`${response.gymSize.value?response.gymSize.value:''}`:''
            return {...prev}
          })
        }
        setBranch(response);
      }
    } catch (error) {
      console.error(error)
    }
  }

  const GetMemberLoginRegistrationInfo=async ()=>{
    try{
      const params = {
        sortBy:"branch",
        branchId:branch._id
      }
      const response = await getMemberLoginRegistrationInfo(user._id,token,params);

      if(response.error){

      }else{
        setBranchMetaData(response);
      }
    }catch(error){
      
    }
  }

  const toggleEditBranch = () => {
    setEditEnabled(!isEditEnabled);
  }

  const handleEditType = (dataType) => {
    setEditType(dataType)
  }

  const toggleInputFields = (id) => event => {
    if (currentElementId == id) {
      setCurrentElementId('');
      setDropdownType("");
    } else {
      setCurrentElementId(id);
      let element = document.getElementById(id);
      if (element) {
        element.focus();
      }
      setDropdownType(id);
      setType(id);
    }
  }


  const onBlurAction = event =>{
    const id = event.target.id;
    if(`${id}`.includes('ip-address-')){
       if(!isValidIP(event.target.value)){
         setBranchInfo(oldstate=>{
            if(oldstate.deviceList.length){
              let index = id.split("-")[id.split("-").length - 1];
              oldstate.deviceList[index]['ipAddress'] = '';
            }
            return {...oldstate};
          })

          new Toast({
            type:'warning',
            duration:3000,
            message:'Invalid IP address'
          })
       }
    }
  }

  const handleChange = (event) => {
    if(currentElementId == "branch-name"){
      setBranchInfo(prev => ({
        ...prev,
        name: event.target.value
      }))
    }else if(currentElementId == 'gym-phone-no'){
       setBranchInfo(prev => {
          prev.address.phoneNumber = event.target.value;
          return {...prev}
        })
    }else if(currentElementId == 'branch-street-address'){
        setBranchInfo(prev => {
          prev.address.streetAddress = event.target.value;
          return {...prev}
        })
    }else if(currentElementId =='nearest-landmark'){
       setBranchInfo(prev => {
          prev.address.nearestLandmark = event.target.value;
          return {...prev}
        })
    }else if(currentElementId == 'zipcode'){
        setBranchInfo(prev => {
          prev.address.zipCode = event.target.value;
          return {...prev}
        })
    } else if(currentElementId == "branch"){
      setBranchInfo(prev => ({
        ...prev,
        branch: event.target.value
      }))
    }else if(currentElementId == "gym-size"){
      setBranchInfo(prev => ({
        ...prev,
        gymSize: event.target.value
      }))
    }else if(currentElementId == "establishment-year"){
      setBranchInfo(prev => ({
        ...prev,
        establishmentYear: event.target.value
      }))
    }else if(currentElementId == "gstin-number"){
      setBranchInfo(prev=>{
        prev.gstin = event.target.value;
        return {...prev};
      })
    }else if(currentElementId.includes("contactuser-")){
      setBranchInfo(oldstate=>{
        if(oldstate.contactInfoList.length){
          let index = currentElementId.split("-")[currentElementId.split("-").length - 1];
          oldstate.contactInfoList[index][currentElementId.split("-")[currentElementId.split("-").length - 2]] = event.target.value;
        }
        return {...oldstate};
      })
    }else if(currentElementId == 'series-name'){
      setBranchInfo(prev=>{
        prev.series.name = event.target.value;
        return {...prev};
      })
    }else if(currentElementId == 'invoice-constant-character'){
      setBranchInfo(prev=>{
        prev.series.invoiceConstant = event.target.value;
        return {...prev};
      })
    }else if(currentElementId == "invoice-first-number") {
      setBranchInfo(prev=>{
        prev.series.firstNumber = event.target.value;
        return {...prev};
      })
    }else if(currentElementId == 'renewal-period'){
      setBranchInfo(prev=>{
        prev.renewalPeriod = event.target.value;
        return {...prev};
      })
    }else if(currentElementId == 'sms-sender-id'){
      setBranchInfo(prev=>{
        prev.smsConfig.senderID = event.target.value;
        return {...prev};
      })
    }else if(currentElementId == 'sms-total-limit'){
      setBranchInfo(prev=>{
        prev.smsConfig.totalSMSLimit = event.target.value;
        return {...prev};
      })
    }else if(currentElementId == 'sms-used'){
      setBranchInfo(prev=>{
        prev.smsConfig.usedSMS = event.target.value;
        return {...prev};
      })
    }else if(currentElementId.includes('device-id-')){
       setBranchInfo(oldstate=>{
        if(oldstate.deviceList.length){
          let index = currentElementId.split("-")[currentElementId.split("-").length - 1];
          oldstate.deviceList[index]['deviceID'] = event.target.value;
        }
        return {...oldstate};
      })
    }else if(currentElementId.includes('gym-slug-')){
       setBranchInfo(oldstate=>{
        if(oldstate.deviceList.length){
          let index = currentElementId.split("-")[currentElementId.split("-").length - 1];
          oldstate.deviceList[index]['gymSlug'] = event.target.value;
        }
        return {...oldstate};
      })
    }else if(currentElementId.includes('ip-address-')){
       setBranchInfo(oldstate=>{
        if(oldstate.deviceList.length){
          let index = currentElementId.split("-")[currentElementId.split("-").length - 1];
          oldstate.deviceList[index]['ipAddress'] = event.target.value;
        }
        return {...oldstate};
      })
    }else if(currentElementId.includes('serial-number-')){
       setBranchInfo(oldstate=>{
        if(oldstate.deviceList.length){
          let index = currentElementId.split("-")[currentElementId.split("-").length - 1];
          oldstate.deviceList[index]['serialNumber'] = event.target.value;
        }
        return {...oldstate};
      })
    }
   
  }

  const handleChangeImage = (event) => {
    const file = event.target.files[0];

    if(file){
      setBranchInfo(prev => ({
        ...prev,
        gymLogo: file
      }))
    }
  }

  const handleSelectDropdownItem = (value) => {
    if(currentElementId == "allowed-gender"){
      setBranchInfo(prev => ({
        ...prev,
        allowedGender: value
      }))
    }else if (currentElementId === "amenities") {
      setBranchInfo(prev => ({
        ...prev,
        amenities: prev.amenities.includes(value)
          ? prev.amenities.filter(item => item !== value)
          : [...prev.amenities, value]
      }));
    }else if(currentElementId === "offered-activities"){
      setBranchInfo(prev => ({
        ...prev,
        offeredActivities : prev.offeredActivities.includes(value)
          ? prev.offeredActivities.filter(item => item !== value)
          : [...prev.offeredActivities, value]
      }));
    } else if(currentElementId.includes("contactuser-")){
       setBranchInfo(oldstate=>{
          if(oldstate.contactInfoList.length){
            let index = currentElementId.split("-")[currentElementId.split("-").length - 1];
            oldstate.contactInfoList[index][currentElementId.split("-")[currentElementId.split("-").length - 2]] = value;
          }
          return {...oldstate};
        })
    } else if(currentElementId.includes("device-type-")){
       setBranchInfo(oldstate=>{
          if(oldstate.deviceList.length){
            let index = currentElementId.split("-")[currentElementId.split("-").length - 1];
            oldstate.deviceList[index]["deviceType"] = value;
          }
          return {...oldstate};
        })
    } else if(currentElementId.includes("deviceList-device-activities-")){
       setBranchInfo(oldstate=>{
          if(oldstate.deviceList.length){
            let index = currentElementId.split("-")[currentElementId.split("-").length - 1];
            oldstate.deviceList[index]['deviceActivity'] = value;
          }
          return {...oldstate};
        })
    }   else {
      
    }
  }

  const handleWeekDays = (index) => {
    setBranchInfo(prev => ({
      ...prev,
      weekDays: prev.weekDays.map((item, i) => 
        i == index ? {
          ...item,
          selected: !item.selected
        } : item )
    }))
  }

  const handleCompany = e =>{
    companyName.current = e.target.value;
  }

  const handleRemoveItem = (type, index) => {
    if(type == "amenities"){
      setBranchInfo(prev => ({
        ...prev,
        amenities: prev.amenities.filter((_, i) => i !== index)
      }))
    }

    if(type == "offered-activities"){
      setBranchInfo(prev => ({
        ...prev,
        offeredActivities: prev.offeredActivities.filter((_, i) => i !== index)
      }))
    }

  } 

  const handleToggleCheckBox = (type) => {
    if(type == "gym-pooling"){
      setBranchInfo(prev => ({
        ...prev,
        gymPooling: !prev.gymPooling
      }))
    }

    if(type == "bulk-sms-dnd"){
      setBranchInfo(prev => ({
        ...prev,
        bulkDNDSms: !prev.bulkDNDSms
      }))
    }
  }

  const handlePrimaryUser = (index) => {
    setBranchInfo(oldstate=>{
      oldstate.contactInfoList[index]['primaryUser']=oldstate.contactInfoList[index]['primaryUser']?false:true
      return {
        ...oldstate
      }
    })
  }

  const toggleEnableDisableCustomSeries = () => {

    setBranchInfo(oldstate=>{
      oldstate.series.customSeries=oldstate.series.customSeries?false:true
      return {
        ...oldstate
      }
    })

  }

  const handleSelectActivity = (data) => {
    handleSelectDropdownItem(data)
  }

  const handleDeviceVendor = (vendor,index) =>{
    setBranchInfo(oldstate=>{
      oldstate.deviceList[index].vendor = vendor;
      return {...oldstate};
    });
  }

  const handleAddDeviceConfiguration = () => {
    setBranchInfo(prev => ({
      ...prev,
      deviceList: [
        ...prev.deviceList,
        { ...biometricInfo }
      ]
    }));
  }

  const toggleBranchAds = () => {
    setAdsViewOpen(!isAdsViewOpen)
  }

  const handleSelectAddress = (elementId,data) => event =>{
    let element = document.getElementById(elementId);
    if(element){
      element.value = data;
      setBranchInfo(oldstate=>{
        if(elementId == "branch"){
          oldstate['branch'] = data;
        }else if(elementId == "city"){
          oldstate['address']['city'] = data;
        }else if(elementId == "state"){
          oldstate['address']['state'] = data;
        }else if(elementId == "country"){
          oldstate['address']['country'] = data;
        }
        return {...oldstate};
      })
      //setBranchInfo({...branchInfo,branch:name})
    }
  }


  const GetAllTax= async () =>{
    try{
      let params = {};
      let response = await getTaxes(user._id,token,params);
      if(!response.error){
        setTaxList(response);
      }
    }catch(error){

    }
  }

  const handleToggleSMS = data =>{
    setBranchInfo(prev=>{
      if(prev.smsConfig.activeNotifications.indexOf(data) == -1) prev.smsConfig.activeNotifications.push(data);
      else prev.smsConfig.activeNotifications.splice(prev.smsConfig.activeNotifications.indexOf(data),1);
      return {...prev};
    })
  }

  const handleToggleWhatsAppNorification = data =>{
    setBranchInfo(prev=>{
      if(prev.whatsAppConfig.activeNotifications.indexOf(data) == -1) prev.whatsAppConfig.activeNotifications.push(data);
      else prev.whatsAppConfig.activeNotifications.splice(prev.whatsAppConfig.activeNotifications.indexOf(data),1);
      return {...prev};
    })
  }


  const handleCompanyScroll = throttle(async (event) => {
    try {
      const { clientHeight, scrollTop, scrollHeight } = event.target;
      if ((scrollTop > 0) && ((Math.ceil((scrollTop + clientHeight)) >= scrollHeight - 5)) && pageNo.company < pageCount.company && !isCompanySpinnerLoader) {
        if (pageNo.company < pageCount.company) {
          pageNo.company = pageNo.company + 1;
          setPageNo({
            ...pageNo
          })
          setCompanySpinnerLoader(true);
          await GetCompanies();
          setCompanySpinnerLoader(false)
        }
      }
    } catch (error) {
      setCompanySpinnerLoader(false)
    }
  }, 800);

  // 1. Generate Key
  const handleGenerateAccessKey = async () => {
    setAccessKeyLoading(true);
    const response = await generateAccessKey(user._id, token, branchId);
    if (response.error) {
        new Toast({ type: "error", duration: 3000, message: response.error });
    } else {
        setAccessKey(response.accessKey);
        new Toast({ type: "success", duration: 3000, message: "Key generated" });
    }
    setAccessKeyLoading(false);
  };
  // 2. Delete Key
  const handleDeleteAccessKey = async () => {
    if (!window.confirm("Delete this key?")) return;
    setAccessKeyLoading(true);
    const response = await deleteAccessKey(user._id, token, branchId);
    if (response.error) {
        new Toast({ type: "error", duration: 3000, message: response.error });
    } else {
        setAccessKey("");
        new Toast({ type: "success", duration: 3000, message: "Key deleted" });
    }
    setAccessKeyLoading(false);
  };

// 3. Copy Key
  const handleCopyAccessKey = () => {
    navigator.clipboard.writeText(accessKey);
    new Toast({ type: "success", duration: 3000, message: "Copied!" });
  };

// 4. Download Key
  const handleDownloadAccessKey = () => {
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([accessKey], { type: "text/plain" }));
    a.download = "access-key.txt";
    a.click();
  };



  useEffect(() => {
    if(isAdsViewOpen) return;
    setVisibleCount(20);
    // reset scroll
    if(countryScrollRef.current) countryScrollRef.current.scrollTop = 0;
    if(stateScrollRef.current) stateScrollRef.current.scrollTop = 0;
    if (branchScrollRef.current) branchScrollRef.current.scrollTop = 0; 
    if(cityScrollRef.current) cityScrollRef.current.scrollTop = 0;
  }, [search,type]);

  // useEffect(()=>{
  //   alert(allItems.length)
  // },[allItems]);


  // useEffect(async ()=>{
  //   try{
  //     if(branch){
  //       await startLoader()
  //       await GetMemberLoginRegistrationInfo();
  //     }
  //     await stopLoader()
  //   }catch(error){
  //     console.error(error);
  //   }
  // },[branch,isReloadContent]);


  useEffect(async () => {
    if(isAdsViewOpen) return;
    try{
      await startLoader()
      if(props.type == "edit") await getSelectedBranch();
      await GetAdmins();
      await GetAllTax();
    }catch(error){

    }
    await stopLoader()
    
  },[])

  useEffect(async ()=>{
    if(isAdsViewOpen) return;
    if(editType == "address"){
        if(branchInfo.branch && document.getElementById("branch") && !document.getElementById("branch").value) document.getElementById("branch").value = branchInfo.branch;
        if(branchInfo.address.city && document.getElementById("city") && !document.getElementById("city").value) document.getElementById("city").value = branchInfo.address.city;
        if(branchInfo.address.state && document.getElementById("state") && !document.getElementById("state").value) document.getElementById("state").value = branchInfo.address.state;
        if(branchInfo.address.country && document.getElementById("country") && !document.getElementById("country").value) document.getElementById("country").value = branchInfo.address.country;
    }else if(editType == "gym-details"){
      if(!companyName.current) companyName.current = companyInfo?.name || '';
      if(document.getElementById("company") && !document.getElementById("company").value) document.getElementById("company").value =  companyInfo?.name || '';
      if(document.getElementById("branch")) document.getElementById("branch").value =  branchInfo?.branch || '';
    }
  },[editType,branchInfo,companyInfo])

  useEffect(async ()=>{
    try{
      if(isAdsViewOpen) return;
      await startLoader()
      await GetCompaniesCount()
      await GetCompanies(true)
    }catch(error){

    }
    await stopLoader();
  },[companySearch])

    useEffect(()=>{
    if(isAdsViewOpen) return;
    if(!isAdsViewOpen){
    if(branchInfo.name){

      let value = false;

      if(branchInfo.series.customSeries && !(branchInfo.series.firstNumber && branchInfo.series.invoiceConstant)){
        value = true
      }
      
      if(
        branchInfo.deviceList.length && 
        branchInfo.deviceList.some(d => (d.deviceType || d.ipAddress || d.serialNumber) && !(d.deviceType && d.ipAddress && d.serialNumber))
      ){
        value = true
      }

      if(!branchInfo.address.streetAddress.length){
        value = true
      }
     
      setButtonLock(value);

    }else{
      setButtonLock(true);
    }
  }
},[branchInfo,isAdsViewOpen]);

  if(isAdsViewOpen){
    return(
      <KioskContent branchId={props.branch._id}/>
    )
  }else{
    return(
      <div className={window.innerWidth < 768 ? "w-full h-full" : "modal-test-container d-flex"}>
        <div className={window.innerWidth < 768 ? "w-full h-full" : "manage-branch-modal slideBottomToTop flex-item"}>
          {window.innerWidth >= 768 && (
            <div className="modal-header space-between bg-blue" style={{background:"var(--darkBlue)", padding:"12px"}}>
              <p className="flex-item fs-18 font-weight-700 color-white">{props.type == "edit" ? "Edit Gym" : "Create Gym"}</p>
              <div onClick={()=>props.toggleAddBranchModal()} className="d-flex desktop-modal-close-button flex-item" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
                <svg className="flex-item" width="24" height="24" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
                </svg>
              </div>
            </div>
          )}
          {
          props.isEditEnabled ? (
            <div className="w-full  " style={window.innerWidth < 768 ? {height:"100%", display:"flex", flexDirection:"column"} : {height:"87%", padding:"12px", display:"flex", flexDirection:"column"}}>
              <div style={window.innerWidth < 768 ? {padding:"12px", flex:1, minHeight:0, display:"flex", flexDirection:"column", overflowY:"auto", overflowX:"hidden"} : {flex:1, minHeight:0, overflowY:"auto"}}>
                
                 <div className={`${window.innerWidth <768 && "mbl-edit-menu"}`}>
                    <div className="d-flex" style={ window.innerWidth < 768 ? { background: "#EAF3FF", borderRadius: "16px", padding: "8px", gap: "8px", width: "100%", alignItems: "stretch" }: {} } >
                      {
                        [
                          {key:"gym-details", label:"Gym Details", icon:(
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{display:"block"}}><path d="M3 10.5L12 3L21 10.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/><path d="M5 9.5V20H19V9.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/><path d="M10 20V13H14V20" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
                          )},
                          {key:"address", label:window.innerWidth < 768 ? <>Address &<br/>contact</> : "Address & Contact Details", icon:(
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{display:"block"}}><path d="M12 21C12 21 19 14.5 19 9.5C19 5.36 15.64 2 12 2C8.36 2 5 5.36 5 9.5C5 14.5 12 21 12 21Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/><circle cx="12" cy="9.5" r="2.5" stroke="currentColor" strokeWidth="1.8"/></svg>
                          )},
                          {key:"invoice", label:"Invoices", icon:(
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{display:"block"}}><path d="M7 2H14L19 7V20C19 21.1 18.1 22 17 22H7C5.9 22 5 21.1 5 20V4C5 2.9 5.9 2 7 2Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/><path d="M14 2V7H19" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
                          )},
                          {key:"configuration", label:window.innerWidth < 768 ? <>SMS & Biometric<br/>Configuration</> : "SMS & Biometric Configuration", icon:(
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{display:"block"}}><rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1.8"/><path d="M8 11V7C8 4.79 9.79 3 12 3C14.21 3 16 4.79 16 7V11" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>
                          )},
                        ].map(tab => (
                          <div
                            key={tab.key}
                            onClick={()=>handleEditType(tab.key)}
                            className="d-flex flex-item"
                            style={
                              window.innerWidth < 768
                                ? {
                                    flexDirection:"column",
                                    alignItems:"center",
                                    justifyContent:"center",
                                    flex:1,
                                    cursor:"pointer",
                                    padding:"12px 4px",
                                    borderRadius:"14px",
                                    background: editType == tab.key ? "#D6E9FF" : "transparent",
                                    transition:"180ms"
                                  }
                                : {}
                            }
                          >
                            {
                              window.innerWidth < 768 ? (
                                <>
                                <div style={{
                                    width:"44px",
                                    height:"44px",
                                    borderRadius:"12px",
                                    flexShrink:0,
                                    display:"flex",
                                    alignItems:"center",
                                    justifyContent:"center",
                                    background: editType == tab.key ? "var(--darkBlue)" : "transparent",
                                    color: editType == tab.key ? "#ffffff" : "var(--darkBlue)",
                                    marginBottom:"8px"
                                  }}>
                                    {tab.icon}
                                </div>
                                  <p className="fs-12 font-weight-700 color-dark-blue" style={{textAlign:"center", lineHeight:"12px", minHeight:"22px"}}>{tab.label}</p>
                                </>
                              ) : (
                                <div className={`d-flex gym-details-menu p-l-16 p-r-16 ${editType == tab.key && "gym-details-menu-active"}`}>
                                  <p className="flex-item">{tab.label}</p>
                                </div>
                              )
                            }
                          </div>
                        ))
                      }
                    </div>
                  </div>

                {
                  editType == "gym-details" && (
                    <div className="w-full m-t-16" style={{overflowY:"auto", height:"85%"}}>
                      {/* <div onClick={toggleInputFields('company')} className={`${(currentElementId == 'company' || companyInfo.name || companyName.current) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-20`} style={{ border: (currentElementId == 'company' || companyInfo.name || companyName.current) ? "1px solid var(--darkBlue)" : "", width: "50%" }}>
                        <div className='d-flex w-full space-between'>
                          <div className='flex-item'>
                            <div className="flex-item d-flex">
                            <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'company' || companyInfo.name ? "10px" : "14px", color: (currentElementId == 'company' || companyInfo.name || companyName.current) ? "var(--darkBlue)" : "", transition: "180ms" }}>Company {props.type == "edit"?'':'*'}</p>
                            </div>
                            <input disabled={props.type == "edit"?true:false} id={'company'} onInput={handleCompany} onChange={_.debounce(handleCompanySearch,700)} placeholder="company Name" className={`${(currentElementId == 'company' || companyInfo.name || companyName.current) ? "active-input-field" : "inactive-input-field"}`} type="text" />
                          </div>
                         {props.type != "edit" && <div className='input-field-arrow-dropdown' style={{ transform: isDropdownType == "company" ? "rotate(180deg)" : "", margin: "12px 8px 4px 0", transition: "180ms" }}>
                            <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                            </svg>
                          </div>}

                          {
                            (isDropdownType == 'company' && props.type != "edit") && (
                              <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1" onScroll={handleCompanyScroll}>
                                {
                                  companies.map((data,idx)=>{
                                    return (
                                      <div key={idx} onClick={()=>handleSelectCompany(data)}  className="global-input-field-arrow-dropdown-item">
                                        <p className="flex-item">{data.name}</p>
                                      </div>
                                    )
                                  })
                                }
                              </div>
                            )
                          }
                        </div>
                      </div> */}
                      <div className="d-flex" style={window.innerWidth < 768 ? {alignItems:"center"} : {}}>
                          <div 
                              className="d-flex create-modal-gym-logo flex-item m-r-20" 
                              style={{
                                position:"relative",
                                width: window.innerWidth < 768 ? "64px" : "110px",
                                height: window.innerWidth < 768 ? "64px" : "108px"
                              }}
                            >
                              {
                                branchInfo.gymLogo ? (
                                  <img 
                                    className="flex-item" 
                                    src={URL.createObjectURL(branchInfo.gymLogo)} 
                                    style={{borderRadius:"50%", width:"100%", height:"100%", objectFit:"cover"}} 
                                  />
                                ) : (
                                  <div 
                                    className="d-flex"
                                    style={{
                                      width:"100%", height:"100%", borderRadius:"50%",
                                      background:"#D9D9D9",
                                      alignItems:"center", justifyContent:"center",
                                      overflow:"hidden"
                                    }}
                                  >
                                    <svg 
                                      width={window.innerWidth < 768 ? "34" : "56"} 
                                      height={window.innerWidth < 768 ? "34" : "56"} 
                                      viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <circle cx="12" cy="8" r="4" fill="#FFFFFF"/>
                                      <path d="M4 20.5C4 16.0817 7.58172 12.5 12 12.5C16.4183 12.5 20 16.0817 20 20.5" stroke="#FFFFFF" strokeWidth="3.2" strokeLinecap="round"/>
                                    </svg>
                                  </div>
                                )
                              }

                              {/* Camera badge — identical on mobile and desktop, just scaled */}
                              <div 
                                className="d-flex" 
                                style={{
                                  position:"absolute", bottom:"0px", right:"0px",
                                  width: window.innerWidth < 768 ? "22px" : "30px", 
                                  height: window.innerWidth < 768 ? "22px" : "30px", 
                                  borderRadius:"50%", background:"var(--darkBlue)", 
                                  border:"2px solid #ffffff", zIndex:3
                                }}
                              >
                                <svg 
                                  className="flex-item margin-auto" 
                                  width={window.innerWidth < 768 ? "11" : "15"} 
                                  height={window.innerWidth < 768 ? "11" : "15"} 
                                  viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path d="M9.5 5C12 5 14 7 14 9.5C14 12 12 14 9.5 14C7 14 5 12 5 9.5C5 7 7 5 9.5 5ZM9.5 6C8.57174 6 7.6815 6.36875 7.02513 7.02513C6.36875 7.6815 6 8.57174 6 9.5C6 10.4283 6.36875 11.3185 7.02513 11.9749C7.6815 12.6313 8.57174 13 9.5 13C10.4283 13 11.3185 12.6313 11.9749 11.9749C12.6313 11.3185 13 10.4283 13 9.5C13 8.57174 12.6313 7.6815 11.9749 7.02513C11.3185 6.36875 10.4283 6 9.5 6ZM3 2H5L7 0H12L14 2H16C16.7956 2 17.5587 2.31607 18.1213 2.87868C18.6839 3.44129 19 4.20435 19 5V14C19 14.7956 18.6839 15.5587 18.1213 16.1213C17.5587 16.6839 16.7956 17 16 17H3C2.20435 17 1.44129 16.6839 0.87868 16.1213C0.316071 15.5587 0 14.7956 0 14V5C0 4.20435 0.316071 3.44129 0.87868 2.87868C1.44129 2.31607 2.20435 2 3 2ZM7.41 1L5.41 3H3C2.46957 3 1.96086 3.21071 1.58579 3.58579C1.21071 3.96086 1 4.46957 1 5V14C1 14.5304 1.21071 15.0391 1.58579 15.4142C1.96086 15.7893 2.46957 16 3 16H16C16.5304 16 17.0391 15.7893 17.4142 15.4142C17.7893 15.0391 18 14.5304 18 14V5C18 4.46957 17.7893 3.96086 17.4142 3.58579C17.0391 3.21071 16.5304 3 16 3H13.59L11.59 1H7.41Z" fill="white"/>
                                </svg>
                              </div>

                              <input 
                                className="cursor-pointer" 
                                onChange={handleChangeImage} 
                                style={{width:"100%", height:"100%", zIndex:2, position:"absolute", top:0, left:0, borderRadius:"50%"}} 
                                type="file" accept="image/*" 
                              />
                            </div>

                          {
                            window.innerWidth < 768 ? (
                              // MOBILE: sirf Gym Name logo ke saath row mein
                              <div onClick={toggleInputFields('branch-name')} className={`${currentElementId == 'branch-name' || branchInfo.name ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: currentElementId == 'branch-name' || branchInfo.name ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                                <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'branch-name' || branchInfo.name ? "10px" : "14px", color: currentElementId == 'branch-name' || branchInfo.name ? "var(--darkBlue)" : "", transition: "180ms" }}>Gym Name *</p>
                                <input id={'branch-name'} onChange={e => handleChange(e)} value={branchInfo.name} placeholder="Enter Gym Name" className={`${currentElementId == 'branch-name' || branchInfo.name ? "active-input-field" : "inactive-input-field"}`} type="text" />
                              </div>
                            ) : (
                              
                              <div className="d-flex-wrap space-between" style={{width:"92%"}}>
                                <div onClick={toggleInputFields('branch-name')} className={`${currentElementId == 'branch-name' || branchInfo.name ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-r-12 m-b-12`} style={{ border: currentElementId == 'branch-name' || branchInfo.name ? "1px solid var(--darkBlue)" : "", width: "49%" }}>
                                  <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'branch-name' || branchInfo.name ? "10px" : "14px", color: currentElementId == 'branch-name' || branchInfo.name ? "var(--darkBlue)" : "", transition: "180ms" }}>Gym Name *</p>
                                  <input id={'branch-name'} onChange={e => handleChange(e)} value={branchInfo.name} placeholder="Enter Gym Name" className={`${currentElementId == 'branch-name' || branchInfo.name ? "active-input-field" : "inactive-input-field"}`} type="text" />
                                </div>
                                <div onClick={toggleInputFields('allowed-gender')} className={`${currentElementId == 'allowed-gender' || branchInfo.allowedGender ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == 'allowed-gender' || branchInfo.allowedGender ? "1px solid var(--darkBlue)" : "",  width: "49%"}}>
                                  <div className='d-flex w-full space-between'>
                                    <div className='flex-item'>
                                      <div className="flex-item d-flex">
                                        <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'allowed-gender' || branchInfo.allowedGender ? "10px" : "", color: currentElementId == 'allowed-gender' || branchInfo.allowedGender ? "var(--darkBlue)" : "", transition: "180ms" }}>Allowed Gender</p>
                                      </div>
                                      <input readOnly value={branchInfo.allowedGender} type="text" className={`${currentElementId == 'allowed-gender' || branchInfo.allowedGender ? "active-input-field" : "inactive-input-field"}`} placeholder="Select allowed gender" />
                                    </div>
                                    <div className='input-field-arrow-dropdown' style={{ transform: isDropdownType == "allowed-gender" ? "rotate(180deg)" : "", margin: "12px 8px 4px 0", transition: "180ms" }}>
                                      <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                                      </svg>
                                    </div>
                                    {
                                      isDropdownType == 'allowed-gender' && (
                                        <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                                          <div onClick={()=>handleSelectDropdownItem("Male")} className="global-input-field-arrow-dropdown-item"><p className="flex-item">Male</p></div>
                                          <div onClick={()=>handleSelectDropdownItem("Female")} className="global-input-field-arrow-dropdown-item"><p className="flex-item">Female</p></div>
                                          <div onClick={()=>handleSelectDropdownItem("Unisex")} className="global-input-field-arrow-dropdown-item"><p className="flex-item">Unisex</p></div>
                                        </div>
                                      )
                                    }
                                  </div>
                                </div>
                                <div onClick={toggleInputFields('gym-size')} className={`${currentElementId == 'gym-size' || branchInfo.gymSize ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-r-12`} style={{ border: currentElementId == 'gym-size' || branchInfo.gymSize ? "1px solid var(--darkBlue)" : "", width: "49%" }}>
                                  <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'gym-size' || branchInfo.gymSize ? "10px" : "14px", color: currentElementId == 'gym-size' || branchInfo.gymSize ? "var(--darkBlue)" : "", transition: "180ms" }}>Total gym size in Sq. Ft.</p>
                                  <input id={'gym-size'} onChange={e => handleChange(e)} value={branchInfo.gymSize} placeholder="Total gym size" className={`${currentElementId == 'gym-size' || branchInfo.gymSize ? "active-input-field" : "inactive-input-field"}`} type="number" />
                                </div>
                                <div onClick={toggleInputFields('establishment-year')} className={`${currentElementId == 'establishment-year' || branchInfo.establishmentYear ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: currentElementId == 'establishment-year' || branchInfo.establishmentYear ? "1px solid var(--darkBlue)" : "", width: "49%" }}>
                                  <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'establishment-year' || branchInfo.establishmentYear ? "10px" : "14px", color: currentElementId == 'establishment-year' || branchInfo.establishmentYear ? "var(--darkBlue)" : "", transition: "180ms" }}>Establishment Year</p>
                                  <input id={'establishment-year'} onChange={e => handleChange(e)} value={branchInfo.establishmentYear} placeholder="Gym Establishment Year" className={`${currentElementId == 'establishment-year' || branchInfo.establishmentYear ? "active-input-field" : "inactive-input-field"}`} type="number" />
                                </div>
                              </div>
                            )
                          }
                        </div>

                        {
                          window.innerWidth < 768 && (
                            // MOBILE ONLY: Allowed Gender, Gym Size, Establishment Year — full-width stacked
                            <div className="w-full m-t-12">
                              <div onClick={toggleInputFields('allowed-gender')} className={`${currentElementId == 'allowed-gender' || branchInfo.allowedGender ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == 'allowed-gender' || branchInfo.allowedGender ? "1px solid var(--darkBlue)" : "",  width: "100%"}}>
                                <div className='d-flex w-full space-between'>
                                  <div className='flex-item'>
                                    <div className="flex-item d-flex">
                                      <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'allowed-gender' || branchInfo.allowedGender ? "10px" : "", color: currentElementId == 'allowed-gender' || branchInfo.allowedGender ? "var(--darkBlue)" : "", transition: "180ms" }}>Allowed Gender</p>
                                    </div>
                                    <input readOnly value={branchInfo.allowedGender} type="text" className={`${currentElementId == 'allowed-gender' || branchInfo.allowedGender ? "active-input-field" : "inactive-input-field"}`} placeholder="Select allowed gender" />
                                  </div>
                                  <div className='input-field-arrow-dropdown' style={{ transform: isDropdownType == "allowed-gender" ? "rotate(180deg)" : "", margin: "12px 8px 4px 0", transition: "180ms" }}>
                                    <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                                    </svg>
                                  </div>
                                  {
                                    isDropdownType == 'allowed-gender' && (
                                      <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                                        <div onClick={()=>handleSelectDropdownItem("Male")} className="global-input-field-arrow-dropdown-item"><p className="flex-item">Male</p></div>
                                        <div onClick={()=>handleSelectDropdownItem("Female")} className="global-input-field-arrow-dropdown-item"><p className="flex-item">Female</p></div>
                                        <div onClick={()=>handleSelectDropdownItem("Unisex")} className="global-input-field-arrow-dropdown-item"><p className="flex-item">Unisex</p></div>
                                      </div>
                                    )
                                  }
                                </div>
                              </div>

                              <div onClick={toggleInputFields('gym-size')} className={`${currentElementId == 'gym-size' || branchInfo.gymSize ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == 'gym-size' || branchInfo.gymSize ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                                <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'gym-size' || branchInfo.gymSize ? "10px" : "14px", color: currentElementId == 'gym-size' || branchInfo.gymSize ? "var(--darkBlue)" : "", transition: "180ms" }}>Total gym size in Sq. Ft.</p>
                                <input id={'gym-size'} onChange={e => handleChange(e)} value={branchInfo.gymSize} placeholder="Total gym size" className={`${currentElementId == 'gym-size' || branchInfo.gymSize ? "active-input-field" : "inactive-input-field"}`} type="number" />
                              </div>

                              <div onClick={toggleInputFields('establishment-year')} className={`${currentElementId == 'establishment-year' || branchInfo.establishmentYear ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: currentElementId == 'establishment-year' || branchInfo.establishmentYear ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                                <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'establishment-year' || branchInfo.establishmentYear ? "10px" : "14px", color: currentElementId == 'establishment-year' || branchInfo.establishmentYear ? "var(--darkBlue)" : "", transition: "180ms" }}>Establishment Year</p>
                                <input id={'establishment-year'} onChange={e => handleChange(e)} value={branchInfo.establishmentYear} placeholder="Gym Establishment Year" className={`${currentElementId == 'establishment-year' || branchInfo.establishmentYear ? "active-input-field" : "inactive-input-field"}`} type="number" />
                              </div>
                            </div>
                          )
                        }
                      {/* <div className="w-full m-t-20">
                        <p className="font-weight-700 color-dark-blue m-b-8">Week Days *</p>
                        <div className="d-flex">
                          {
                            branchInfo.weekDays.map((data, index) => {
                              return(
                                <div onClick={()=>handleWeekDays(index)} className="d-flex session-item cursor-pointer m-r-14" style={{background:data.selected ? "var(--darkBlue)" : "#FFFFFF"}}>
                                  {
                                    data.selected ? (
                                      <svg className="flex-item" width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="12" height="12" rx="2" fill="white"/>
                                        <path d="M2.5 6.22727L4.83333 8.5L9.5 3.5" stroke="var(--darkBlue)" stroke-width="1.5" stroke-linecap="round"/>
                                      </svg>
                                    ) : (
                                      <svg className="flex-item" width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.5" y="0.5" width="11" height="11" rx="1.5" fill="white" stroke="#D3D3D3"/>
                                      </svg>
                                    )
                                  }
                                  <p className="flex-item font-weight-600 m-l-12" style={{color: data.selected && "#ffffff"}}>{data.day}</p>
                                </div>        
                              )
                            })
                          }
                        </div>
                      </div> */}
                      <div onClick={toggleInputFields('amenities')} className={`${currentElementId == 'amenities' || branchInfo.amenities.length > 0 ? "member-global-input-field input-field-auto-height flex-item" : "member-global-input-field input-field-auto-height flex-item d-flex"} m-t-20`} style={{ border: currentElementId == 'amenities' || branchInfo.amenities.length > 0 ? "1px solid var(--darkBlue)" : "",  width: "100%", minHeight:"60px", maxHeight:"300px"}}>
                        <div className='d-flex w-full space-between'>
                          <div className='flex-item w-full'>
                            <div className="flex-item d-flex">
                              <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'amenities' || branchInfo.amenities.length > 0 ? "10px" : "", color: currentElementId == 'amenities' || branchInfo.amenities.length > 0 ? "var(--darkBlue)" : "", transition: "180ms" }}>Amenities/Facilities</p>
                            </div>
                            <div onClick={e => e.stopPropagation()} className="d-flex-wrap" style={{maxWidth:"90%"}}>
                              {
                                branchInfo.amenities && branchInfo.amenities.length > 0 && (
                                  branchInfo.amenities.map((data,index) => {
                                    return(
                                      <div className="flex-item d-flex input-field-chips m-r-12 m-t-2 m-b-8">
                                        <p className="flex-item m-r-12">{data}</p>
                                        <svg onClick={()=>handleRemoveItem('amenities', index)} className="flex-item" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M1 7L7 1M7 7L1 1" stroke="#E52525" stroke-miterlimit="10" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                      </div>
                                    )
                                  })
                                )
                              }
                            </div>
                          </div>
                          <div className='input-field-arrow-dropdown' style={{ transform: isDropdownType == 'amenities' ? "rotate(180deg)" : "", margin: "18px 16px 4px 0", transition: "180ms" }}>
                            <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                            </svg>
                          </div>
                        </div>
                        {
                            isDropdownType == 'amenities' && (
                              <div onClick={e=>e.stopPropagation()} className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1" style={{top:"auto", bottom:"-270px"}}>
                                {
                                  amenities.map(data => {
                                    return(  
                                      <div onClick={()=>handleSelectDropdownItem(data)} className="global-input-field-arrow-dropdown-item">
                                        <p className="flex-item">{data}</p>
                                      </div>
                                    )
                                  })
                                }
                              </div>
                            )
                          }
                      </div>
                      <div onClick={toggleInputFields('offered-activities')} className={`${currentElementId == 'offered-activities' || branchInfo.offeredActivities.length > 0 ? "member-global-input-field input-field-auto-height flex-item" : "member-global-input-field input-field-auto-height flex-item d-flex"} m-t-20`} style={{ border: currentElementId == 'offered-activities' || branchInfo.offeredActivities.length > 0 ? "1px solid var(--darkBlue)" : "",  width: "100%", minHeight:"60px", maxHeight:"300px"}}>
                        <div className='d-flex w-full space-between'>
                          <div className='flex-item w-full'>
                            <div className="flex-item d-flex">
                              <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'offered-activities' || branchInfo.offeredActivities.length > 0 ? "10px" : "", color: currentElementId == 'offered-activities' || branchInfo.offeredActivities.length > 0 ? "var(--darkBlue)" : "", transition: "180ms" }}>Activities Offered</p>
                            </div>
                            <div onClick={e => e.stopPropagation()} className="d-flex-wrap" style={{maxWidth:"90%"}}>
                              {
                                branchInfo.offeredActivities && branchInfo.offeredActivities.length > 0 && (
                                  branchInfo.offeredActivities.map((data,index) => {
                                    return(
                                      <div onClick={()=>handleRemoveItem('offered-activities', index)} className="flex-item d-flex input-field-chips m-r-12 m-t-2 m-b-8">
                                        <p className="flex-item m-r-12">{data}</p>
                                        <svg className="flex-item" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M1 7L7 1M7 7L1 1" stroke="#E52525" stroke-miterlimit="10" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                      </div>
                                    )
                                  })
                                )
                              }
                            </div>
                          </div>
                          <div className='input-field-arrow-dropdown' style={{ transform: isDropdownType == 'offered-activities' ? "rotate(180deg)" : "", margin: "18px 16px 4px 0", transition: "180ms" }}>
                            <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                            </svg>
                          </div>
                        </div>
                        {
                            isDropdownType == 'offered-activities' && (
                              <div onClick={e=>e.stopPropagation()} className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1" style={{top:"auto", bottom:"-270px"}}>
                                {
                                  offeredActivities.map(data => {
                                    return(  
                                      <div onClick={()=>handleSelectDropdownItem(data)} className="global-input-field-arrow-dropdown-item">
                                        <p className="flex-item">{data}</p>
                                      </div>
                                    )
                                  })
                                }
                              </div>
                            )
                          }
                      </div>
                      <div className="d-flex m-t-20">
                        {/* <div onClick={()=>handleToggleCheckBox("gym-pooling")} className="d-flex m-r-20 cursor-pointer">
                          {branchInfo.gymPooling ? (
                            <svg className="flex-item" width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect width="16" height="16" rx="4" fill="var(--darkBlue)"/>
                              <path d="M3.33398 8.30302L6.4451 11.3333L12.6673 4.66666" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                            </svg>
                          ): (
                            <svg className="flex-item" width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="white" stroke="#B8B8B8"/>
                            </svg>
                          )}
                          <p className="flex-item m-l-12 font-weight-600">Enable Gym Pooling</p>
                        </div> */}
                        {/* <div onClick={()=>handleToggleCheckBox("bulk-sms-dnd")} className="d-flex cursor-pointer">
                          {branchInfo.bulkDNDSms ? (
                            <svg className="flex-item" width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect width="16" height="16" rx="4" fill="var(--darkBlue)"/>
                              <path d="M3.33398 8.30302L6.4451 11.3333L12.6673 4.66666" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                            </svg>
                          ): (
                            <svg className="flex-item" width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="white" stroke="#B8B8B8"/>
                            </svg>
                          )}
                          <p className="flex-item m-l-12 font-weight-600">Send Bulk SMS to DND number</p>
                        </div> */}
                      </div>
                    </div>
                  )
                }

               {
              editType == "address" && (
                <div className="w-full m-t-16 no-scroll-bar" style={{overflowY:"auto", height:"85%"}}>
                  <p className="font-weight-700 color-dark-blue m-b-12 fs-16">Address</p>
                  {
                    window.innerWidth < 768 ? (
                // MOBILE LAYOUT
              <>
            {/* Street Address - full width */}
            <div onClick={toggleInputFields('branch-street-address')} className={`${currentElementId == 'branch-street-address' || branchInfo.address.streetAddress ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == 'branch-street-address' || branchInfo.address.streetAddress ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
              <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'branch-street-address' || branchInfo.address.streetAddress ? "10px" : "14px", color: currentElementId == 'branch-street-address' || branchInfo.address.streetAddress ? "var(--darkBlue)" : "", transition: "180ms" }}>Street Address *</p>
              <input id={'branch-street-address'} onChange={e => handleChange(e)} value={branchInfo.address.streetAddress} placeholder="Enter Street Address" className={`${currentElementId == 'branch-street-address' || branchInfo.address.streetAddress ? "active-input-field" : "inactive-input-field"}`} type="text" />
            </div>

            {/* Nearest Landmark - full width */}
            <div onClick={toggleInputFields('nearest-landmark')} className={`${currentElementId == 'nearest-landmark' || branchInfo.address.nearestLandmark ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == 'nearest-landmark' || branchInfo.address.nearestLandmark ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
              <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'nearest-landmark' || branchInfo.address.nearestLandmark ? "10px" : "14px", color: currentElementId == 'nearest-landmark' || branchInfo.address.nearestLandmark ? "var(--darkBlue)" : "", transition: "180ms" }}>Nearest Landmark</p>
              <input id={'nearest-landmark'} onChange={e => handleChange(e)} value={branchInfo.address.nearestLandmark} placeholder="Enter Nearest Landmark" className={`${currentElementId == 'nearest-landmark' || branchInfo.address.nearestLandmark ? "active-input-field" : "inactive-input-field"}`} type="text" />
            </div>

            {/* Row: ZIP Code + City */}
            <div className="d-flex space-between m-b-12">
              <div onClick={toggleInputFields('zipcode')} className={`${currentElementId == 'zipcode' || branchInfo.address.zipCode ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: currentElementId == 'zipcode' || branchInfo.address.zipCode ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
                <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'zipcode' || branchInfo.address.zipCode ? "10px" : "14px", color: currentElementId == 'zipcode' || branchInfo.address.zipCode ? "var(--darkBlue)" : "", transition: "180ms" }}>ZIP Code</p>
                <input id={'zipcode'} onChange={e => handleChange(e)} value={branchInfo.address.zipCode} placeholder="Zip Code" className={`${currentElementId == 'zipcode' || branchInfo.address.zipCode ? "active-input-field" : "inactive-input-field"}`} type="number" />
              </div>

              <div onClick={toggleInputFields('city')} className={`${currentElementId == 'city' || branchInfo.address.city ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: currentElementId == 'city' || branchInfo.address.city ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
                <div className='d-flex w-full space-between'>
                  <div className='flex-item'>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'city' || branchInfo.address.city ? "10px" : "", color: currentElementId == 'city' || branchInfo.address.city ? "var(--darkBlue)" : "", transition: "180ms" }}>City</p>
                    </div>
                    <input id="city" onChange={_.debounce(handleSearch,700)} type="text" className={`${currentElementId == 'city' || branchInfo.address.city ? "active-input-field" : "inactive-input-field"}`} placeholder="Select a city" />
                  </div>
                  <div className='input-field-arrow-dropdown' style={{ transform: isDropdownType == "city" ? "rotate(180deg)" : "", margin: "12px 8px 4px 0", transition: "180ms" }}>
                    <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" strokeLinecap="round" />
                    </svg>
                  </div>
                  {
                    isDropdownType == 'city' && (
                      <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1" ref={cityScrollRef} onScroll={handleScroll}>
                        {loading && <p className="p-2">Loading...</p>}
                        {
                          !loading && displayedItems.map((data,idx)=>(
                            <div key={idx} onClick={handleSelectAddress("city",data)} className="global-input-field-arrow-dropdown-item">
                              <p className="flex-item">{data}</p>
                            </div>
                          ))
                        }
                        {!loading && visibleCount < filteredItems.length && (
                          <p className="text-center py-2">Loading more...</p>
                        )}
                      </div>
                    )
                  }
                </div>
              </div>
            </div>

            {/* Row: State + Country */}
            <div className="d-flex space-between m-b-12">
              <div onClick={toggleInputFields('state')} className={`${currentElementId == 'state' || branchInfo.address.state ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: currentElementId == 'state' || branchInfo.address.state ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
                <div className='d-flex w-full space-between'>
                  <div className='flex-item'>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'state' || branchInfo.address.state ? "10px" : "", color: currentElementId == 'state' || branchInfo.address.state ? "var(--darkBlue)" : "", transition: "180ms" }}>State</p>
                    </div>
                    <input id="state" onChange={_.debounce(handleSearch,700)} type="text" className={`${currentElementId == 'state' || branchInfo.address.state ? "active-input-field" : "inactive-input-field"}`} placeholder="Select a state" />
                  </div>
                  <div className='input-field-arrow-dropdown' style={{ transform: isDropdownType == "state" ? "rotate(180deg)" : "", margin: "12px 8px 4px 0", transition: "180ms" }}>
                    <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" strokeLinecap="round" />
                    </svg>
                  </div>
                  {
                    isDropdownType == 'state' && (
                      <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1" ref={stateScrollRef} onScroll={handleScroll}>
                        {loading && <p className="p-2">Loading...</p>}
                        {
                          !loading && displayedItems.map((data,idx)=>(
                            <div key={idx} onClick={handleSelectAddress("state",data)} className="global-input-field-arrow-dropdown-item">
                              <p className="flex-item">{data}</p>
                            </div>
                          ))
                        }
                        {!loading && visibleCount < filteredItems.length && (
                          <p className="text-center py-2">Loading more...</p>
                        )}
                      </div>
                    )
                  }
                </div>
              </div>

              <div onClick={toggleInputFields('country')} className={`${currentElementId == 'country' || branchInfo.address.country ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: currentElementId == 'country' || branchInfo.address.country ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
                <div className='d-flex w-full space-between'>
                  <div className='flex-item'>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'country' || branchInfo.address.country ? "10px" : "", color: currentElementId == 'country' || branchInfo.address.country ? "var(--darkBlue)" : "", transition: "180ms" }}>Country</p>
                    </div>
                    <input id="country" onChange={_.debounce(handleSearch,700)} type="text" className={`${currentElementId == 'country' || branchInfo.address.country ? "active-input-field" : "inactive-input-field"}`} placeholder="Select a country" />
                  </div>
                  <div className='input-field-arrow-dropdown' style={{ transform: isDropdownType == "country" ? "rotate(180deg)" : "", margin: "12px 8px 4px 0", transition: "180ms" }}>
                    <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" strokeLinecap="round" />
                    </svg>
                  </div>
                  {
                    isDropdownType == 'country' && (
                      <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1" ref={countryScrollRef} onScroll={handleScroll}>
                        {loading && <p className="p-2">Loading...</p>}
                        {
                          !loading && displayedItems.map((data,idx)=>(
                            <div key={idx} onClick={handleSelectAddress("country",data)} className="global-input-field-arrow-dropdown-item">
                              <p className="flex-item">{data}</p>
                            </div>
                          ))
                        }
                        {!loading && visibleCount < filteredItems.length && (
                          <p className="text-center py-2">Loading more...</p>
                        )}
                      </div>
                    )
                  }
                </div>
              </div>
            </div>
          </>
        ) : (
          // ===== DESKTOP LAYOUT (fragment se wrap kiya) =====
          <>
            <div className="d-flex-wrap space-between">
              <div onClick={toggleInputFields('branch-street-address')} className={`${currentElementId == 'branch-street-address' || branchInfo.address.streetAddress ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == 'branch-street-address' || branchInfo.address.streetAddress ? "1px solid var(--darkBlue)" : "", width: "49.30%" }}>
                <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'branch-street-address' || branchInfo.address.streetAddress ? "10px" : "14px", color: currentElementId == 'branch-street-address' || branchInfo.address.streetAddress ? "var(--darkBlue)" : "", transition: "180ms" }}>Street Address *</p>
                <input id={'branch-street-address'} onChange={e => handleChange(e)} value={branchInfo.address.streetAddress} placeholder="Enter Street Address" className={`${currentElementId == 'branch-street-address' || branchInfo.address.streetAddress ? "active-input-field" : "inactive-input-field"}`} type="text" />
              </div>
              <div onClick={toggleInputFields('nearest-landmark')} className={`${currentElementId == 'nearest-landmark' || branchInfo.address.nearestLandmark ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == 'nearest-landmark' || branchInfo.address.nearestLandmark ? "1px solid var(--darkBlue)" : "", width: "49.30%" }}>
                <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'nearest-landmark' || branchInfo.address.nearestLandmark ? "10px" : "14px", color: currentElementId == 'nearest-landmark' || branchInfo.address.nearestLandmark ? "var(--darkBlue)" : "", transition: "180ms" }}>Nearest Landmark</p>
                <input id={'nearest-landmark'} onChange={e => handleChange(e)} value={branchInfo.address.nearestLandmark} placeholder="Enter Nearest Landmark" className={`${currentElementId == 'nearest-landmark' || branchInfo.address.nearestLandmark ? "active-input-field" : "inactive-input-field"}`} type="text" />
              </div>
            </div>
            <div className="d-flex-wrap space-between">
              <div onClick={toggleInputFields('zipcode')} className={`${currentElementId == 'zipcode' || branchInfo.address.zipCode ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == 'zipcode' || branchInfo.address.zipCode ? "1px solid var(--darkBlue)" : "", width: "24%" }}>
                <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'zipcode' || branchInfo.address.zipCode ? "10px" : "14px", color: currentElementId == 'zipcode' || branchInfo.address.zipCode ? "var(--darkBlue)" : "", transition: "180ms" }}>Zipcode</p>
                <input id={'zipcode'} onChange={e => handleChange(e)} value={branchInfo.address.zipCode} placeholder="Enter Street Address" className={`${currentElementId == 'zipcode' || branchInfo.address.zipCode ? "active-input-field" : "inactive-input-field"}`} type="number" />
              </div>
              <div onClick={toggleInputFields('country')} className={`${currentElementId == 'country' || branchInfo.address.country ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == 'country' || branchInfo.address.country ? "1px solid var(--darkBlue)" : "",  width: "24%"}}>
                <div className='d-flex w-full space-between'>
                  <div className='flex-item'>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'country' || branchInfo.address.country ? "10px" : "", color: currentElementId == 'country' || branchInfo.address.country ? "var(--darkBlue)" : "", transition: "180ms" }}>Country</p>
                    </div>
                    <input id="country" onChange={_.debounce(handleSearch,700)} type="text" className={`${currentElementId == 'country' || branchInfo.address.country ? "active-input-field" : "inactive-input-field"}`} placeholder="Select a country" />
                  </div>
                  <div className='input-field-arrow-dropdown' style={{ transform: isDropdownType == "country" ? "rotate(180deg)" : "", margin: "12px 8px 4px 0", transition: "180ms" }}>
                    <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" strokeLinecap="round" />
                    </svg>
                  </div>
                  {
                    isDropdownType == 'country' && (
                      <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1" ref={countryScrollRef} onScroll={handleScroll}>
                        {loading && <p className="p-2">Loading...</p>}
                        {
                          !loading && displayedItems.map((data,idx)=>(
                            <div key={idx} onClick={handleSelectAddress("country",data)} className="global-input-field-arrow-dropdown-item">
                              <p className="flex-item">{data}</p>
                            </div>
                          ))
                        }
                        {!loading && visibleCount < filteredItems.length && (
                          <p className="text-center py-2">Loading more...</p>
                        )}
                      </div>
                    )
                  }
                </div>
              </div>
              <div onClick={toggleInputFields('state')} className={`${currentElementId == 'state' || branchInfo.address.state ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == 'state' || branchInfo.address.state ? "1px solid var(--darkBlue)" : "",  width: "24%"}}>
                <div className='d-flex w-full space-between'>
                  <div className='flex-item'>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'state' || branchInfo.address.state ? "10px" : "", color: currentElementId == 'state' || branchInfo.address.state ? "var(--darkBlue)" : "", transition: "180ms" }}>State</p>
                    </div>
                    <input id="state" onChange={_.debounce(handleSearch,700)} type="text" className={`${currentElementId == 'state' || branchInfo.address.state ? "active-input-field" : "inactive-input-field"}`} placeholder="Select a state" />
                  </div>
                  <div className='input-field-arrow-dropdown' style={{ transform: isDropdownType == "state" ? "rotate(180deg)" : "", margin: "12px 8px 4px 0", transition: "180ms" }}>
                    <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" strokeLinecap="round" />
                    </svg>
                  </div>
                  {
                    isDropdownType == 'state' && (
                      <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1" ref={stateScrollRef} onScroll={handleScroll}>
                        {loading && <p className="p-2">Loading...</p>}
                        {
                          !loading && displayedItems.map((data,idx)=>(
                            <div key={idx} onClick={handleSelectAddress("state",data)} className="global-input-field-arrow-dropdown-item">
                              <p className="flex-item">{data}</p>
                            </div>
                          ))
                        }
                        {!loading && visibleCount < filteredItems.length && (
                          <p className="text-center py-2">Loading more...</p>
                        )}
                      </div>
                    )
                  }
                </div>
              </div>
              <div onClick={toggleInputFields('city')} className={`${currentElementId == 'city' || branchInfo.address.city ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == 'city' || branchInfo.address.city ? "1px solid var(--darkBlue)" : "",  width: "24%"}}>
                <div className='d-flex w-full space-between'>
                  <div className='flex-item'>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'city' || branchInfo.address.city ? "10px" : "", color: currentElementId == 'city' || branchInfo.address.city ? "var(--darkBlue)" : "", transition: "180ms" }}>City</p>
                    </div>
                    <input id="city" onChange={_.debounce(handleSearch,700)} type="text" className={`${currentElementId == 'city' || branchInfo.address.city ? "active-input-field" : "inactive-input-field"}`} placeholder="Select a city" />
                  </div>
                  <div className='input-field-arrow-dropdown' style={{ transform: isDropdownType == "city" ? "rotate(180deg)" : "", margin: "12px 8px 4px 0", transition: "180ms" }}>
                    <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" strokeLinecap="round" />
                    </svg>
                  </div>
                  {
                    isDropdownType == 'city' && (
                      <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1" ref={cityScrollRef} onScroll={handleScroll}>
                        {loading && <p className="p-2">Loading...</p>}
                        {
                          !loading && displayedItems.map((data,idx)=>(
                            <div key={idx} onClick={handleSelectAddress("city",data)} className="global-input-field-arrow-dropdown-item">
                              <p className="flex-item">{data}</p>
                            </div>
                          ))
                        }
                        {!loading && visibleCount < filteredItems.length && (
                          <p className="text-center py-2">Loading more...</p>
                        )}
                      </div>
                    )
                  }
                </div>
              </div>
            </div>
          </>
        )
      }
    </div>
  )
}
                      {/* <div onClick={toggleInputFields('gym-phone-no')} className={`${currentElementId == 'gym-phone-no' || branchInfo.address.phoneNumber ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == 'gym-phone-no' || branchInfo.address.phoneNumber ? "1px solid var(--darkBlue)" : "", width: "24%" }}>
                        <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'gym-phone-no' || branchInfo.address.phoneNumber ? "10px" : "14px", color: currentElementId == 'gym-phone-no' || branchInfo.address.phoneNumber ? "var(--darkBlue)" : "", transition: "180ms" }}>Phone Number *</p>
                        <input id={'gym-phone-no'} onChange={e => handleChange(e)} value={branchInfo.address.phoneNumber} placeholder="Enter Phone Number" className={`${currentElementId == 'gym-phone-no' || branchInfo.address.phoneNumber ? "active-input-field" : "inactive-input-field"}`} type="number" />
                      </div> */}

                      {/* {
                        props.type != "edit" && [
                          <p className="font-weight-700 color-dark-blue m-t-24 m-b-12 fs-16">Contact Info <span className="color-red">(Gym Admin) *</span></p>,
                          branchInfo.contactInfoList.map((data, index) => {
                            return(
                              <div className="add-info-container w-full bg-white m-b-12">
                                <div className="d-flex-wrap w-full">
                                  <div className="flex-item d-flex w-full space-between">
                                    <div onClick={toggleInputFields('contactuser-name-'+index)} className={`${currentElementId == 'contactuser-name-'+index || data.name ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-r-12`} style={{ border: currentElementId == 'contactuser-name-'+index || data.name ? "1px solid var(--darkBlue)" : "", width: "32%" }}>
                                      <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'contactuser-name-'+index || data.name ? "10px" : "14px", color: currentElementId == 'contactuser-name-'+index || data.name ? "var(--darkBlue)" : "", transition: "180ms" }}>Name *</p>
                                      <input id={'contactuser-name-'+index} onChange={e => handleChange(e)} value={data.name} placeholder="Enter User Name" className={`${currentElementId == 'contactuser-name-'+index || data.name ? "active-input-field" : "inactive-input-field"}`} type="text" />
                                    </div>
                                    <div onClick={toggleInputFields('contactuser-contacts-'+index)} className={`${currentElementId == 'contactuser-contacts-'+index || data.contacts.length > 0 ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-r-12`} style={{ border: currentElementId == 'contactuser-contacts-'+index || data.contacts.length > 0 ? "1px solid var(--darkBlue)" : "", width: "32%" }}>
                                      <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'contactuser-contacts-'+index || data.contacts.length > 0 ? "10px" : "14px", color: currentElementId == 'contactuser-contacts-'+index || data.contacts.length > 0 ? "var(--darkBlue)" : "", transition: "180ms" }}>Phone *</p>
                                      <input id={'contactuser-contacts-'+index} onChange={e => handleChange(e)} value={data.contacts} className={`${currentElementId == 'contactuser-contacts-'+index || data.contacts.length > 0 ? "active-input-field" : "inactive-input-field"}`} type="text" />
                                    </div>
                                    <div onClick={toggleInputFields('contactuser-emailAddress-'+index)} className={`${currentElementId == 'contactuser-emailAddress-'+index || data.emailAddress.length > 0 ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: currentElementId == 'contactuser-emailAddress-'+index || data.emailAddress.length > 0 ? "1px solid var(--darkBlue)" : "", width: "32%" }}>
                                      <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'contactuser-emailAddress-'+index || data.emailAddress.length > 0 ? "10px" : "14px", color: currentElementId == 'contactuser-emailAddress-'+index || data.emailAddress.length > 0 ? "var(--darkBlue)" : "", transition: "180ms" }}>Email *</p>
                                      <input id={'contactuser-emailAddress-'+index} onChange={e => handleChange(e)} value={data.emailAddress} className={`${currentElementId == 'contactuser-emailAddress-'+index || data.emailAddress.length > 0 ? "active-input-field" : "inactive-input-field"}`} type="text" />
                                    </div>
                                    <div onClick={toggleInputFields('contactuser-type-'+index)} className={`${currentElementId == 'contactuser-type-'+index || data.type ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-l-12`} style={{ border: currentElementId == 'contactuser-type-'+index || data.type ? "1px solid var(--darkBlue)" : "",  width: "46%"}}>
                                      <div className='d-flex w-full space-between'>
                                        <div className='flex-item'>
                                          <div className="flex-item d-flex">
                                            <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'contactuser-type-'+index || data.type ? "10px" : "", color: currentElementId == 'contactuser-type-'+index || data.type ? "var(--darkBlue)" : "", transition: "180ms" }}>User Type *</p>
                                          </div>
                                          <input readOnly value={data.type} type="text" className={`${currentElementId == 'contactuser-type-'+index || data.type ? "active-input-field" : "inactive-input-field"}`} placeholder="Select User Type" />
                                        </div>
                                        <div className='input-field-arrow-dropdown' style={{ transform: isDropdownType == "contactuser-type-"+index ? "rotate(180deg)" : "", margin: "12px 8px 4px 0", transition: "180ms" }}>
                                          <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                                          </svg>
                                        </div>
                                        {
                                          isDropdownType == 'contactuser-type-'+index && (
                                            <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                                              <div onClick={()=>handleSelectDropdownItem("Poc")} className="global-input-field-arrow-dropdown-item">
                                                <p className="flex-item">Poc</p>
                                              </div>
                                              <div onClick={()=>handleSelectDropdownItem("Manager")} className="global-input-field-arrow-dropdown-item">
                                                <p className="flex-item">Manager</p>
                                              </div>
                                              <div onClick={()=>handleSelectDropdownItem("Receptionist")} className="global-input-field-arrow-dropdown-item">
                                                <p className="flex-item">Receptionist</p>
                                              </div>
                                            </div>
                                          )
                                        }
                                      </div>
                                    </div>
                                  </div>   
                                  <div className="flex-item d-flex">
                                    onClick={()=>handlePrimaryUser(index)}
                                    <div className="flex-item global-button-container d-flex flex-item cursor-pointer" style={{borderRadius:"25px", height:"50px", background:"var(--darkBlue)"}}>
                                      <p className="flex-item" style={{color:"#ffffff"}}>Gym Admin</p>
                                      {
                                        data.primaryUser ? (
                                          <svg className="flex-item m-l-12" width="24" height="24" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="14" cy="14" r="14" fill="var(--darkBlue)"/>
                                            <path d="M6 15L11 20L21 9" stroke="white" stroke-width="2" stroke-linecap="round"/>
                                          </svg>
                                        ) : (
                                          <svg className="flex-item m-l-12" width="24" height="24" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="14" cy="14" r="13" fill="white" stroke="#A1A1A1" stroke-width="2"/>
                                          </svg>
                                        )
                                      }
                                    </div>
                                    <div onClick={removeContactInfo(index)} className="flex-item d-flex branch-header-action m-l-12 cursor-pointer" style={{width:"50px",height:"50px", background:"#FFE3E3"}}>
                                      <svg className="flex-item margin-auto svg-fill" width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3.20202 19.1667C2.66068 19.1667 2.1999 18.9766 1.81968 18.5964C1.43946 18.2161 1.24935 17.7558 1.24935 17.2152V2.25002H0.0410156V1.04168H4.87435V0.111267H12.1243V1.04168H16.9577V2.25002H15.7493V17.2152C15.7493 17.7711 15.5633 18.2355 15.1911 18.6084C14.8189 18.9814 14.3541 19.1675 13.7967 19.1667H3.20202ZM14.541 2.25002H2.45768V17.2152C2.45768 17.4319 2.52736 17.6099 2.66672 17.7493C2.80608 17.8887 2.98452 17.9584 3.20202 17.9584H13.7979C13.9832 17.9584 14.1535 17.881 14.309 17.7264C14.4645 17.5717 14.5418 17.4009 14.541 17.214V2.25002ZM5.85068 15.5417H7.05902V4.66668H5.85068V15.5417ZM9.93968 15.5417H11.148V4.66668H9.93968V15.5417Z" fill="#E33A34"/>
                                      </svg>
                                    </div>
                                  </div>             
                                </div>
                              </div>
                            )
                          }),
                          <div className="d-flex"> 
                            <div onClick={addNewContactInfo} className={`global-button-container d-flex flex-item m-t-12`} style={{borderRadius:"15px", height:"30px"}}>
                              <p className="flex-item" style={{fontWeight:"600"}}>Add New Contact Information</p>
                            </div>
                          </div>
                        ]
                      } 
                    </div>
                  )
                }*/}

                            {
                                editType == "invoice" && (
                                  <div className="w-full m-t-16 no-scroll-bar" style={{overflowY:"auto", height:"85%"}}>
                                    {
                                      window.innerWidth < 768 ? (
                                        //MOBILE LAYOUT
                                        <>
                                          {/* GSTIN - full width */}
                                          <div onClick={toggleInputFields('gstin-number')} className={`${currentElementId == 'gstin-number' || branchInfo.gstin ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-6`} style={{ border: currentElementId == 'gstin-number' || branchInfo.gstin ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                                            <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'gstin-number' || branchInfo.gstin ? "10px" : "14px", color: currentElementId == 'gstin-number' || branchInfo.gstin ? "var(--darkBlue)" : "", transition: "180ms" }}>GSTIN</p>
                                            <input id={'gstin-number'} onChange={e => handleChange(e)} value={branchInfo.gstin} placeholder="eg. 22AAAAA0000A1Z5" className={`${currentElementId == 'gstin-number' || branchInfo.gstin ? "active-input-field" : "inactive-input-field"}`} type="text" />
                                          </div>
                                          <p className="flex-item fs-12 m-b-20" style={{fontStyle:"italic", fontWeight:"300", color:"#303030"}}>Note: GSTIN should be 15 characters long.</p>

                                          {/* Series section - full width */}
                                          <div className="series-container bg-white m-b-20">
                                            <div className="d-flex w-full space-between m-b-12">
                                              <p className="flex-item fs-16 font-weight-700 color-dark-blue">Series *</p>
                                              <div className="d-flex">
                                                <p className="flex-item fs-16 font-weight-700 m-r-20">Custom Series</p>
                                                <div className="flex-item">
                                                  <div onClick={()=>toggleEnableDisableCustomSeries()} className='toggle-button margin-auto d-flex' style={{backgroundColor: branchInfo.series.customSeries == true && "#B3E28F"}}>
                                                    <div className='toggle-ball flex-item' style={{right: branchInfo.series.customSeries ? 0:'auto', left: !branchInfo.series.customSeries ? 0:'auto', backgroundColor: branchInfo.series.customSeries == true && "#5d883c"}} />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>

                                            <div onClick={toggleInputFields('invoice-constant-character')} className={`${((currentElementId == 'invoice-constant-character' || branchInfo.series.invoiceConstant) ) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: ((currentElementId == 'invoice-constant-character' || branchInfo.series.invoiceConstant) ) ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                                              <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'invoice-constant-character' || branchInfo.series.invoiceConstant ? "10px" : "14px", color: ((currentElementId == 'invoice-constant-character' || branchInfo.series.invoiceConstant) ) ? "var(--darkBlue)" : "", transition: "180ms" }}>Invoice constant character *</p>
                                              <input id={'invoice-constant-character'} disabled={!branchInfo.series.customSeries} onChange={e => handleChange(e)} value={branchInfo.series.invoiceConstant} placeholder="Enter Series Name" className={`${((currentElementId == 'invoice-constant-character' || branchInfo.series.invoiceConstant) ) ? "active-input-field" : "inactive-input-field"}`} type="text" />
                                            </div>

                                            <div onClick={toggleInputFields('invoice-first-number')} className={`${((currentElementId == 'invoice-first-number' || branchInfo.series.firstNumber) ) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: ((currentElementId == 'invoice-first-number' || branchInfo.series.firstNumber) ) ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                                              <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'invoice-first-number' || branchInfo.series.firstNumber ? "10px" : "14px", color: ((currentElementId == 'invoice-first-number' || branchInfo.series.firstNumber) ) ? "var(--darkBlue)" : "", transition: "180ms" }}>First Number *</p>
                                              <input id={'invoice-first-number'} disabled={!branchInfo.series.customSeries} onChange={e => handleChange(e)} value={branchInfo.series.firstNumber} placeholder="Enter Series Name" className={`${((currentElementId == 'invoice-first-number' || branchInfo.series.firstNumber) ) ? "active-input-field" : "inactive-input-field"}`} type="text" />
                                            </div>
                                          </div>

                                          {/* Tax Name / Percentage - full width, at bottom */}
                                          <div className="tax-info-container flex-item bg-white" style={{width:'100%'}}>
                                            <div className="d-flex space-between m-b-12">
                                              <div className="tax-name">
                                                <p className="font-weight-700">Tax Name</p>
                                              </div>
                                              <div className="tax-percent">
                                                <p className="margin-auto font-weight-700">Percentage</p>
                                              </div>
                                            </div>
                                            {
                                              taxList.map(data => {
                                                return(
                                                  <div className="d-flex space-between m-b-12">
                                                    <div className="d-flex tax-name" onClick={handleSelectTax(data._id)}>
                                                      {
                                                        branchInfo.includedTax.indexOf(data._id) == -1 ? (
                                                          <svg className="flex-item m-r-6" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <rect x="0.5" y="0.5" width="14" height="14" rx="3.5" fill="#F5F5F5" stroke="#888888"/>
                                                          </svg>
                                                        ):(
                                                          <svg className="flex-item m-r-6" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <rect width="15" height="15" rx="4" fill="var(--darkBlue)"/>
                                                            <path d="M4 7.72727L6.33333 10L11 5" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
                                                          </svg>
                                                        )
                                                      }
                                                      <p className="flex-item">{data.name}</p>
                                                    </div>
                                                    <div className="tax-percent">
                                                      <p className="margin-auto">{data.value}%</p>
                                                    </div>
                                                  </div>
                                                )
                                              })
                                            }
                                          </div>
                                        </>
                                      ) : (
                                        //DESKTOP LAYOUT
                                        <>
                                          <div className="d-flex space-between">
                                            <div className="tax-info-container flex-item bg-white" style={{width:'35%'}}>
                                              <div className="d-flex space-between m-b-12">
                                                <div className="tax-name">
                                                  <p className="font-weight-700">Tax Name</p>
                                                </div>
                                                <div className="tax-percent">
                                                  <p className="margin-auto font-weight-700">Percentage</p>
                                                </div>
                                              </div>
                                              {
                                                taxList.map(data => {
                                                  return(
                                                    <div className="d-flex space-between m-b-12">
                                                      <div className="d-flex tax-name" onClick={handleSelectTax(data._id)}>
                                                        {
                                                          branchInfo.includedTax.indexOf(data._id) == -1 ? (
                                                            <svg className="flex-item m-r-6" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                              <rect x="0.5" y="0.5" width="14" height="14" rx="3.5" fill="#F5F5F5" stroke="#888888"/>
                                                            </svg>
                                                          ):(
                                                            <svg className="flex-item m-r-6" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                              <rect width="15" height="15" rx="4" fill="var(--darkBlue)"/>
                                                              <path d="M4 7.72727L6.33333 10L11 5" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
                                                            </svg>
                                                          )
                                                        }
                                                        <p className="flex-item">{data.name}</p>
                                                      </div>
                                                      <div className="tax-percent">
                                                        <p className="margin-auto">{data.value}%</p>
                                                      </div>
                                                    </div>
                                                  )
                                                })
                                              }
                                            </div>
                                            <div style={{width:'63%'}}>
                                              <div onClick={toggleInputFields('gstin-number')} className={`${currentElementId == 'gstin-number' || branchInfo.gstin ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-6`} style={{ border: currentElementId == 'gstin-number' || branchInfo.gstin ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                                                <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'gstin-number' || branchInfo.gstin ? "10px" : "14px", color: currentElementId == 'gstin-number' || branchInfo.gstin ? "var(--darkBlue)" : "", transition: "180ms" }}>GSTIN</p>
                                                <input id={'gstin-number'} onChange={e => handleChange(e)} value={branchInfo.gstin} placeholder="eg. 22AAAAA0000A1Z5" className={`${currentElementId == 'gstin-number' || branchInfo.gstin ? "active-input-field" : "inactive-input-field"}`} type="text" />
                                              </div>
                                              <p className="flex-item fs-12" style={{fontStyle:"italic", fontWeight:"300", color:"#303030"}}>Note: GSTIN should be 15 characters long.</p>
                                              <div className="series-container bg-white m-t-20">
                                                <div className="d-flex w-full space-between m-b-12">
                                                  <p className="flex-item fs-16 font-weight-700 color-dark-blue">Series *</p>
                                                  <div className="d-flex">
                                                    <p className="flex-item fs-16 font-weight-700 m-r-20">Custom Series</p>
                                                    <div className="flex-item">
                                                      <div onClick={()=>toggleEnableDisableCustomSeries()} className='toggle-button margin-auto d-flex' style={{backgroundColor: branchInfo.series.customSeries == true && "#B3E28F"}}>
                                                        <div className='toggle-ball flex-item' style={{right: branchInfo.series.customSeries ? 0:'auto', left: !branchInfo.series.customSeries ? 0:'auto', backgroundColor: branchInfo.series.customSeries == true && "#5d883c"}} />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div onClick={toggleInputFields('invoice-constant-character')} className={`${((currentElementId == 'invoice-constant-character' || branchInfo.series.invoiceConstant) ) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: ((currentElementId == 'invoice-constant-character' || branchInfo.series.invoiceConstant) ) ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                                                  <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'invoice-constant-character' || branchInfo.series.invoiceConstant ? "10px" : "14px", color: ((currentElementId == 'invoice-constant-character' || branchInfo.series.invoiceConstant) ) ? "var(--darkBlue)" : "", transition: "180ms" }}>Invoice constant character *</p>
                                                  <input id={'invoice-constant-character'} disabled={!branchInfo.series.customSeries} onChange={e => handleChange(e)} value={branchInfo.series.invoiceConstant} placeholder="Enter Series Name" className={`${((currentElementId == 'invoice-constant-character' || branchInfo.series.invoiceConstant) ) ? "active-input-field" : "inactive-input-field"}`} type="text" />
                                                </div>
                                                <div onClick={toggleInputFields('invoice-first-number')} className={`${((currentElementId == 'invoice-first-number' || branchInfo.series.firstNumber) ) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: ((currentElementId == 'invoice-first-number' || branchInfo.series.firstNumber) ) ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                                                  <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'invoice-first-number' || branchInfo.series.firstNumber ? "10px" : "14px", color: ((currentElementId == 'invoice-first-number' || branchInfo.series.firstNumber) ) ? "var(--darkBlue)" : "", transition: "180ms" }}>First Number *</p>
                                                  <input id={'invoice-first-number'} disabled={!branchInfo.series.customSeries} onChange={e => handleChange(e)} value={branchInfo.series.firstNumber} placeholder="Enter Series Name" className={`${((currentElementId == 'invoice-first-number' || branchInfo.series.firstNumber) ) ? "active-input-field" : "inactive-input-field"}`} type="text" />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      )
                                    }
                                  </div>
                                )
                              }

                              {
                    editType == "configuration" && (
                      <div className="w-full m-t-16 no-scroll-bar" style={{overflowY:"auto", height:"85%"}}>
                        {
                          window.innerWidth < 768 ? (
                            //MOBILE LAYOUT 
                            <>
                              {/* Renewal Period - small full width box */}
                             <div onClick={toggleInputFields('renewal-period')} className={`${currentElementId == 'renewal-period' || branchInfo.renewalPeriod ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-6`} style={{ border: currentElementId == 'renewal-period' || branchInfo.renewalPeriod ? "1px solid var(--darkBlue)" : "", width: "50%" }}>
                              <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'renewal-period' || branchInfo.renewalPeriod ? "10px" : "14px", color: currentElementId == 'renewal-period' || branchInfo.renewalPeriod ? "var(--darkBlue)" : "", transition: "180ms" }}>Renewal Period</p>
                              <input id={'renewal-period'} onChange={e => handleChange(e)} value={branchInfo.renewalPeriod} placeholder="Enter Renewal period" className={`${currentElementId == 'renewal-period' || branchInfo.renewalPeriod ? "active-input-field" : "inactive-input-field"}`} type="number" />
                            </div>
                              <p className="flex-item fs-12 m-b-16" style={{fontStyle:"italic", color:"#6d6d6d"}}>Note: Enter in no of days</p>

                              {/* SMS Notification card - full width */}
                              <div className="msg-container bg-white m-b-20" style={{width:"100%"}}>
                                <p className="fs-14 color-dark-blue font-weight-700 m-b-12">SMS Notification</p>
                                <div onClick={toggleInputFields('sms-sender-id')} className={`${currentElementId == 'sms-sender-id' || branchInfo.smsConfig.senderID ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-6`} style={{ border: currentElementId == 'sms-sender-id' || branchInfo.smsConfig.senderID ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                                  <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'sms-sender-id' || branchInfo.smsConfig.senderID ? "10px" : "14px", color: currentElementId == 'sms-sender-id' || branchInfo.smsConfig.senderID ? "var(--darkBlue)" : "", transition: "180ms" }}>SMS Sender ID</p>
                                  <input id={'sms-sender-id'} onChange={e => handleChange(e)} value={branchInfo.smsConfig.senderID} placeholder="Enter Sender ID" className={`${currentElementId == 'sms-sender-id' || branchInfo.smsConfig.senderID ? "active-input-field" : "inactive-input-field"}`} type="text" />
                                </div>
                                <p className="flex-item fs-12 m-b-12" style={{fontStyle:"italic", color:"#6d6d6d"}}>Note: Enter Sender Id using 6 Char</p>

                                <div className="d-flex space-between">
                                  <div onClick={toggleInputFields('sms-total-limit')} className={`${currentElementId == 'sms-total-limit' || branchInfo.smsConfig.totalSMSLimit ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-20`} style={{ border: currentElementId == 'sms-total-limit' || branchInfo.smsConfig.totalSMSLimit ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
                                    <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'sms-total-limit' || branchInfo.smsConfig.totalSMSLimit ? "10px" : "14px", color: currentElementId == 'sms-total-limit' || branchInfo.smsConfig.totalSMSLimit ? "var(--darkBlue)" : "", transition: "180ms" }}>Total SMS Limit</p>
                                    <input id={'sms-total-limit'} onChange={e => handleChange(e)} value={branchInfo.smsConfig.totalSMSLimit} placeholder="Enter SMS Limit" className={`${currentElementId == 'sms-total-limit' || branchInfo.smsConfig.totalSMSLimit ? "active-input-field" : "inactive-input-field"}`} type="text" />
                                  </div>
                                  <div onClick={toggleInputFields('sms-used')} className={`${currentElementId == 'sms-used' || branchInfo.smsConfig.usedSMS ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-20`} style={{ border: currentElementId == 'sms-used' || branchInfo.smsConfig.usedSMS ? "1px solid var(--darkBlue)" : "", width: "48%", background:'#E2F5FF' }}>
                                    <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'sms-used' || branchInfo.smsConfig.usedSMS ? "10px" : "14px", color: currentElementId == 'sms-used' || branchInfo.smsConfig.usedSMS ? "var(--darkBlue)" : "", transition: "180ms" }}>User SMS Limit</p>
                                    <input id={'sms-used'} onChange={e => handleChange(e)} value={branchInfo.smsConfig.usedSMS} className={`${currentElementId == 'sms-used' || branchInfo.smsConfig.usedSMS ? "active-input-field" : "inactive-input-field"}`} disabled type="text" />
                                  </div>
                                </div>

                                <div className="d-flex" onClick={()=>handleToggleSMS("notify-payment")}>
                                  {
                                    branchInfo.smsConfig.activeNotifications.indexOf("notify-payment") == -1 ? (
                                      <svg className="flex-item m-r-8" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#F1F1F1" stroke="#989898"/>
                                      </svg>
                                    ):(
                                      <svg className="flex-item m-r-8" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="15" height="15" rx="4" fill="var(--darkBlue)"/>
                                        <path d="M4 7.72727L6.33333 10L11 5" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
                                      </svg>
                                    )
                                  }
                                  <p className="flex-item color-red font-weight-700" style={{lineHeight:"14px"}}>Sms notify payments</p>
                                            {/* <div className="msg-container bg-white">
                                            <p className="fs-14 color-dark-blue font-weight-700 m-b-12">WhatsApp Notification</p>
                                            <div className="d-flex m-b-8" onClick={()=>handleToggleWhatsAppNorification("balance-due-reminder")}>
                                              {
                                                  branchInfo.whatsAppConfig.activeNotifications.indexOf("balance-due-reminder") == -1 ? (
                                                    <svg className="flex-item m-r-8" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#F1F1F1" stroke="#989898"/>
                                                  </svg>
                                                  ):(
                                                    <svg className="flex-item m-r-8" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                      <rect width="15" height="15" rx="4" fill="var(--darkBlue)"/>
                                                      <path d="M4 7.72727L6.33333 10L11 5" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                    </svg>
                                                  )
                                                }

                                                <p className="flex-item color-red font-weight-700" style={{lineHeight:"14px"}}>Balance due Reminder</p>
                                            </div>
                                            <div className="d-flex m-b-8" onClick={()=>handleToggleWhatsAppNorification("membership-sale")}>
                                              {
                                                  branchInfo.whatsAppConfig.activeNotifications.indexOf("membership-sale") == -1 ? (
                                                    <svg className="flex-item m-r-8" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#F1F1F1" stroke="#989898"/>
                                                  </svg>
                                                  ):(
                                                    <svg className="flex-item m-r-8" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                      <rect width="15" height="15" rx="4" fill="var(--darkBlue)"/>
                                                      <path d="M4 7.72727L6.33333 10L11 5" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                    </svg>
                                                  )
                                              }
                                              <p className="flex-item color-red font-weight-700" style={{lineHeight:"14px"}}>Membership Sale</p>
                                            </div>
                                            <div className="d-flex m-b-8" onClick={()=>handleToggleWhatsAppNorification("membership-expiry")}>
                                              {
                                                  branchInfo.whatsAppConfig.activeNotifications.indexOf("membership-expiry") == -1 ? (
                                                    <svg className="flex-item m-r-8" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#F1F1F1" stroke="#989898"/>
                                                  </svg>
                                                  ):(
                                                    <svg className="flex-item m-r-8" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                      <rect width="15" height="15" rx="4" fill="var(--darkBlue)"/>
                                                      <path d="M4 7.72727L6.33333 10L11 5" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                    </svg>
                                                  )
                                                }
                                              <p className="flex-item color-red font-weight-700" style={{lineHeight:"14px"}}>Membership Expiry</p>
                                            </div>
                                              <div className="d-flex m-b-8" onClick={()=>handleToggleWhatsAppNorification("enquiry")}>
                                              {
                                              branchInfo.whatsAppConfig.activeNotifications.indexOf("enquiry") == -1 ? (
                                                <svg className="flex-item m-r-8" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#F1F1F1" stroke="#989898"/>
                                              </svg>
                                              ):(
                                                <svg className="flex-item m-r-8" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <rect width="15" height="15" rx="4" fill="var(--darkBlue)"/>
                                                  <path d="M4 7.72727L6.33333 10L11 5" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                </svg>
                                              )
                                            }
                                              <p className="flex-item color-red font-weight-700" style={{lineHeight:"14px"}}>Enquiry</p>
                                            </div>
                                            <div className="d-flex m-b-8" onClick={()=>handleToggleWhatsAppNorification("birthday")}>
                                              {
                                              branchInfo.whatsAppConfig.activeNotifications.indexOf("birthday") == -1 ? (
                                                <svg className="flex-item m-r-8" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#F1F1F1" stroke="#989898"/>
                                              </svg>
                                              ):(
                                                <svg className="flex-item m-r-8" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <rect width="15" height="15" rx="4" fill="var(--darkBlue)"/>
                                                  <path d="M4 7.72727L6.33333 10L11 5" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                </svg>
                                              )
                                            }
                                              <p className="flex-item color-red font-weight-700" style={{lineHeight:"14px"}}>Birthday</p>
                                            </div>
                                              <div className="d-flex m-b-8" onClick={()=>handleToggleWhatsAppNorification("membership-renewal-reminder")}>
                                                {
                                                  branchInfo.whatsAppConfig.activeNotifications.indexOf("membership-renewal-reminder") == -1 ? (
                                                    <svg className="flex-item m-r-8" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#F1F1F1" stroke="#989898"/>
                                                  </svg>
                                                  ):(
                                                    <svg className="flex-item m-r-8" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                      <rect width="15" height="15" rx="4" fill="var(--darkBlue)"/>
                                                      <path d="M4 7.72727L6.33333 10L11 5" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                    </svg>
                                                  )
                                                }
                                              <p className="flex-item color-red font-weight-700" style={{lineHeight:"14px"}}>Renewal Reminder</p>
                                            </div>
                                          </div> */}

                                </div>
                              </div>

                              {/* Biometric Configuration heading + devices */}
                              <p className="fs-14 color-dark-blue font-weight-700 m-b-12">Biometric Configuration</p>
                              {
                                branchInfo.deviceList.length > 0 && branchInfo.deviceList.map((data, index) => {
                                  return(
                                    <div className="add-info-container w-full bg-white m-b-12" key={index}>
                                      <div className="d-flex-wrap space-between">
                                                  {/* <div onClick={toggleInputFields('device-id-'+index)} className={`${currentElementId == 'device-id-'+index || data.deviceID ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == 'device-id-'+index || data.deviceID ? "1px solid var(--darkBlue)" : "", width: "24%" }}>
                                                    <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'device-id-'+index || data.deviceID ? "10px" : "14px", color: currentElementId == 'device-id-'+index || data.deviceID ? "var(--darkBlue)" : "", transition: "180ms" }}>Device ID *</p>
                                                    <input id={'device-id-'+index} onChange={e => handleChange(e)} value={data.deviceID} placeholder="Enter Device ID" className={`${currentElementId == 'device-id-'+index || data.deviceID ? "active-input-field" : "inactive-input-field"}`} type="text" />
                                                  </div> */}

                                        <div onClick={toggleInputFields('serial-number-'+index)} className={`${currentElementId == 'serial-number-'+index || data.serialNumber ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == 'serial-number-'+index || data.serialNumber ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                                          <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'serial-number-'+index || data.serialNumber ? "10px" : "14px", color: currentElementId == 'serial-number-'+index || data.serialNumber ? "var(--darkBlue)" : "", transition: "180ms" }}>Serial Number/Host name *</p>
                                          <input id={'serial-number-'+index} onChange={e => handleChange(e)} value={data.serialNumber} placeholder="Enter Serial Number/Host name" className={`${currentElementId == 'serial-number-'+index || data.serialNumber ? "active-input-field" : "inactive-input-field"}`} type="text" />
                                        </div>
                                        <div onClick={toggleInputFields('ip-address-'+index)} className={`${currentElementId == 'ip-address-'+index || data.ipAddress ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == 'ip-address-'+index || data.ipAddress ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
                                          <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'ip-address-'+index || data.ipAddress ? "10px" : "14px", color: currentElementId == 'ip-address-'+index || data.ipAddress ? "var(--darkBlue)" : "", transition: "180ms" }}>Ip address *</p>
                                          <input id={'ip-address-'+index} onChange={e => handleChange(e)} value={data.ipAddress} onBlur={onBlurAction} placeholder="Enter IP Address" className={`${currentElementId == 'ip-address-'+index || data.ipAddress ? "active-input-field" : "inactive-input-field"}`} type="text" />
                                        </div>
                                        <div onClick={toggleInputFields('deviceList-device-activities-'+index)} className={`${currentElementId == 'deviceList-device-activities-'+index || data.deviceActivity ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == 'deviceList-device-activities-'+index || data.deviceActivity ? "1px solid var(--darkBlue)" : "",  width: "48%"}}>
                                          <div className='d-flex w-full space-between'>
                                            <div className='flex-item'>
                                              <div className="flex-item d-flex">
                                                <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'deviceList-device-activities-'+index || data.deviceActivity ? "10px" : "", color: currentElementId == 'deviceList-device-activities-'+index || data.deviceActivity ? "var(--darkBlue)" : "", transition: "180ms" }}>Device Activities</p>
                                              </div>
                                              <input readOnly value={data.deviceActivity} type="text" className={`${currentElementId == 'deviceList-device-activities-'+index || data.deviceActivity ? "active-input-field" : "inactive-input-field"}`} placeholder="Select User Activity" />
                                            </div>
                                            <div className='input-field-arrow-dropdown' style={{ transform: isDropdownType == 'deviceList-device-activities-'+index ? "rotate(180deg)" : "", margin: "12px 8px 4px 0", transition: "180ms" }}>
                                              <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" strokeLinecap="round" />
                                              </svg>
                                            </div>
                                            {
                                              isDropdownType == 'deviceList-device-activities-'+index && (
                                                <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                                                  {
                                                    deviceActivities.map((data,idx) => {
                                                      return(
                                                        <div key={idx} onClick={()=>handleSelectActivity(data)} className="global-input-field-arrow-dropdown-item">
                                                          <p className="flex-item">{data}</p>
                                                        </div>
                                                      )
                                                    })
                                                  }
                                                </div>
                                              )
                                            }
                                          </div>
                                        </div>
                                        <div onClick={toggleInputFields('device-type-'+index)} className={`${currentElementId == 'device-type-'+index || data.deviceType ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == 'device-type-'+index || data.deviceType ? "1px solid var(--darkBlue)" : "",  width: "48%"}}>
                                          <div className='d-flex w-full space-between'>
                                            <div className='flex-item'>
                                              <div className="flex-item d-flex">
                                                <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'device-type-'+index || data.deviceType ? "10px" : "", color: currentElementId == 'device-type-'+index || data.deviceType ? "var(--darkBlue)" : "", transition: "180ms" }}>Device type *</p>
                                              </div>
                                              <input readOnly value={data.deviceType} type="text" className={`${currentElementId == 'device-type-'+index || data.deviceType ? "active-input-field" : "inactive-input-field"}`} placeholder="Select Device Type" />
                                            </div>
                                            <div className='input-field-arrow-dropdown' style={{ transform: isDropdownType == 'device-type-'+index ? "rotate(180deg)" : "", margin: "12px 8px 4px 0", transition: "180ms" }}>
                                              <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" strokeLinecap="round" />
                                              </svg>
                                            </div>
                                            {
                                              isDropdownType == 'device-type-'+index && (
                                                <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                                                  <div onClick={()=>handleSelectActivity("Dumbell")} className="global-input-field-arrow-dropdown-item">
                                                    <p className="flex-item">Dumbell</p>
                                                  </div>
                                                  <div onClick={()=>handleSelectActivity("Biometric")} className="global-input-field-arrow-dropdown-item">
                                                    <p className="flex-item">Biometric</p>
                                                  </div>
                                                </div>
                                              )
                                            }
                                          </div>
                                        </div>
                                        <div onClick={toggleInputFields('vendor-'+index)} className={`${currentElementId == 'vendor-'+index || data.vendor ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: currentElementId == 'vendor-'+index || data.vendor ? "1px solid var(--darkBlue)" : "",  width: "100%"}}>
                                          <div className='d-flex w-full space-between'>
                                            <div className='flex-item'>
                                              <div className="flex-item d-flex">
                                                <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'vendor-'+index || data.vendor ? "10px" : "", color: currentElementId == 'vendor-'+index || data.vendor ? "var(--darkBlue)" : "", transition: "180ms" }}>Vendor *</p>
                                              </div>
                                              <input readOnly value={data.vendor} type="text" className={`${currentElementId == 'vendor-'+index || data.vendor ? "active-input-field" : "inactive-input-field"}`} placeholder="Select vendor" />
                                            </div>
                                            <div className='input-field-arrow-dropdown' style={{ transform: isDropdownType == 'vendor-'+index ? "rotate(180deg)" : "", margin: "12px 8px 4px 0", transition: "180ms" }}>
                                              <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" strokeLinecap="round" />
                                              </svg>
                                            </div>
                                            {
                                              isDropdownType == 'vendor-'+index && (
                                                <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                                                  <div onClick={()=>handleDeviceVendor("ESSL",index)} className="global-input-field-arrow-dropdown-item">
                                                    <p className="flex-item">ESSL</p>
                                                  </div>
                                                  <div onClick={()=>handleDeviceVendor("BIOMAX",index)} className="global-input-field-arrow-dropdown-item">
                                                    <p className="flex-item">BIOMAX</p>
                                                  </div>
                                                </div>
                                              )
                                            }
                                          </div>
                                        </div>
                                      </div>
                                     <div className="d-flex" style={{flexDirection:'row-reverse',marginTop:"16px"}}>
                                      <div 
                                        onClick={()=>removeBiometricDevice(index)} 
                                        className="d-flex cursor-pointer" 
                                        style={{ background:"#FFB3B3",borderRadius:"25px", padding:"8px 20px", alignItems:"center", justifyContent:"center", gap:"8px"}}>
                                        <svg width="18" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M3.20202 19.1667C2.66068 19.1667 2.1999 18.9766 1.81968 18.5964C1.43946 18.2161 1.24935 17.7558 1.24935 17.2152V2.25002H0.0410156V1.04168H4.87435V0.111267H12.1243V1.04168H16.9577V2.25002H15.7493V17.2152C15.7493 17.7711 15.5633 18.2355 15.1911 18.6084C14.8189 18.9814 14.3541 19.1675 13.7967 19.1667H3.20202ZM14.541 2.25002H2.45768V17.2152C2.45768 17.4319 2.52736 17.6099 2.66672 17.7493C2.80608 17.8887 2.98452 17.9584 3.20202 17.9584H13.7979C13.9832 17.9584 14.1535 17.881 14.309 17.7264C14.4645 17.5717 14.5418 17.4009 14.541 17.214V2.25002ZM5.85068 15.5417H7.05902V4.66668H5.85068V15.5417ZM9.93968 15.5417H11.148V4.66668H9.93968V15.5417Z" fill="#E33A34"/>
                                        </svg>
                                        <p style={{margin:0, color:"#E33A34", fontWeight:"600", fontSize:"16px"}}>Delete</p>
                                      </div>
                                    </div>
                                    </div>
                                  )
                                })
                              }

                                {/* Add New Biometric Information */}
                                <div onClick={()=>handleAddDeviceConfiguration()} className="d-flex">
                                  <div 
                                    className="global-button-container d-flex flex-item m-t-12" 
                                    style={{
                                      borderRadius:"25px", 
                                      height:"38px", 
                                      width:"auto", 
                                      padding:"0 20px",
                                      background:"#EDEDED"
                                    }}
                                  >
                                    <p className="flex-item" style={{fontWeight:"600"}}>Add New Biometric Information</p>
                                  </div>
                                </div>

                                {/* Generate Key */}
                                {!accessKey && (
                                  <div onClick={accessKeyLoading ? null : handleGenerateAccessKey} className="d-flex">
                                    <div 
                                      className="global-button-container d-flex flex-item m-t-12" 
                                      style={{
                                        borderRadius:"25px", 
                                        height:"38px", 
                                        width:"auto", 
                                        padding:"0 20px",
                                        background:"#EDEDED"
                                      }}
                                    >
                                      <p className="flex-item" style={{fontWeight:"600"}}>
                                        {accessKeyLoading ? "Generating..." : "Generate Key"}
                                      </p>
                                    </div>
                                  </div>
                                )}

                              {accessKey && (
                                <div style={{marginTop:"8px"}}>
                                  <div className="d-flex" style={{background:"#E8E8E8", borderRadius:"20px", padding:"6px 16px", width:"fit-content"}}>
                                    <p style={{margin:0, fontSize:"13px"}}>{accessKey}</p>
                                  </div>
                                  <div className="d-flex" style={{gap:"8px", marginTop:"6px"}}>
                                    <div onClick={handleCopyAccessKey} style={{background:"#E8E8E8", borderRadius:"12px", padding:"4px 12px", cursor:"pointer"}}>
                                      <p style={{margin:0, fontSize:"12px"}}>Copy</p>
                                    </div>
                                    <div onClick={handleDownloadAccessKey} style={{background:"#E8E8E8", borderRadius:"12px", padding:"4px 12px", cursor:"pointer"}}>
                                      <p style={{margin:0, fontSize:"12px"}}>Download</p>
                                    </div>
                                    <div onClick={handleDeleteAccessKey} style={{background:"#E8E8E8", borderRadius:"12px", padding:"4px 12px", cursor:"pointer"}}>
                                      <p style={{margin:0, fontSize:"12px"}}>Delete</p>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          ) : (
                            //DESKTOP LAYOUT 
                            <>
                              <div onClick={toggleInputFields('renewal-period')} className={`${currentElementId == 'renewal-period' || branchInfo.renewalPeriod ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-6`} style={{ border: currentElementId == 'renewal-period' || branchInfo.renewalPeriod ? "1px solid var(--darkBlue)" : "", width: "25%" }}>
                                <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'renewal-period' || branchInfo.renewalPeriod ? "10px" : "14px", color: currentElementId == 'renewal-period' || branchInfo.renewalPeriod ? "var(--darkBlue)" : "", transition: "180ms" }}>Renewal Period</p>
                                <input id={'renewal-period'} onChange={e => handleChange(e)} value={branchInfo.renewalPeriod} placeholder="Enter Renewal period" className={`${currentElementId == 'renewal-period' || branchInfo.renewalPeriod ? "active-input-field" : "inactive-input-field"}`} type="number" />
                              </div>
                              <p className="flex-item fs-12" style={{fontStyle:"italic", color:"#6d6d6d"}}>Note: Enter in no of days</p>
                              <div className="d-flex space-between m-t-12 m-b-20">
                                <div className="msg-container bg-white">
                                  <p className="fs-14 color-dark-blue font-weight-700 m-b-12">SMS Notification</p>
                                  <div onClick={toggleInputFields('sms-sender-id')} className={`${currentElementId == 'sms-sender-id' || branchInfo.smsConfig.senderID ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-6`} style={{ border: currentElementId == 'sms-sender-id' || branchInfo.smsConfig.senderID ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                                    <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'sms-sender-id' || branchInfo.smsConfig.senderID ? "10px" : "14px", color: currentElementId == 'sms-sender-id' || branchInfo.smsConfig.senderID ? "var(--darkBlue)" : "", transition: "180ms" }}>SMS Sender ID</p>
                                    <input id={'sms-sender-id'} onChange={e => handleChange(e)} value={branchInfo.smsConfig.senderID} placeholder="Enter Sender ID" className={`${currentElementId == 'sms-sender-id' || branchInfo.smsConfig.senderID ? "active-input-field" : "inactive-input-field"}`} type="text" />
                                  </div>
                                  <p className="flex-item fs-12 m-b-12" style={{fontStyle:"italic", color:"#6d6d6d"}}>Note: Enter Sender Id using 6 Char</p>
                                  <div className="d-flex"> 
                                    <div onClick={toggleInputFields('sms-total-limit')} className={`${currentElementId == 'sms-total-limit' || branchInfo.smsConfig.totalSMSLimit ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-20 m-r-12`} style={{ border: currentElementId == 'sms-total-limit' || branchInfo.smsConfig.totalSMSLimit ? "1px solid var(--darkBlue)" : "", width: "35%" }}>
                                      <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'sms-total-limit' || branchInfo.smsConfig.totalSMSLimit ? "10px" : "14px", color: currentElementId == 'sms-total-limit' || branchInfo.smsConfig.totalSMSLimit ? "var(--darkBlue)" : "", transition: "180ms" }}>Total SMS Limit</p>
                                      <input id={'sms-total-limit'} onChange={e => handleChange(e)} value={branchInfo.smsConfig.totalSMSLimit} placeholder="Enter SMS Limit" className={`${currentElementId == 'sms-total-limit' || branchInfo.smsConfig.totalSMSLimit ? "active-input-field" : "inactive-input-field"}`} type="text" />
                                    </div>
                                    <div onClick={toggleInputFields('sms-used')} className={`${currentElementId == 'sms-used' || branchInfo.smsConfig.usedSMS ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-20 m-r-12`} style={{ border: currentElementId == 'sms-used' || branchInfo.smsConfig.usedSMS ? "1px solid var(--darkBlue)" : "", width: "35%", background:'#E2F5FF' }}>
                                      <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'sms-used' || branchInfo.smsConfig.usedSMS ? "10px" : "14px", color: currentElementId == 'sms-used' || branchInfo.smsConfig.usedSMS ? "var(--darkBlue)" : "", transition: "180ms" }}>User SMS Limit</p>
                                      <input id={'sms-used'} onChange={e => handleChange(e)} value={branchInfo.smsConfig.usedSMS} className={`${currentElementId == 'sms-used' || branchInfo.smsConfig.usedSMS ? "active-input-field" : "inactive-input-field"}`} disabled type="text" />
                                    </div>
                                  </div>
                                  <div className="d-flex" onClick={()=>handleToggleSMS("notify-payment")}>
                                    {
                                      branchInfo.smsConfig.activeNotifications.indexOf("notify-payment") == -1 ? (
                                        <svg className="flex-item m-r-8" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#F1F1F1" stroke="#989898"/>
                                        </svg>
                                      ):(
                                        <svg className="flex-item m-r-8" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <rect width="15" height="15" rx="4" fill="var(--darkBlue)"/>
                                          <path d="M4 7.72727L6.33333 10L11 5" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
                                        </svg>
                                      )
                                    }
                                    <p className="flex-item color-red font-weight-700" style={{lineHeight:"14px"}}>Sms notify payments</p>
                                            {/* <div className="msg-container bg-white">
                                            <p className="fs-14 color-dark-blue font-weight-700 m-b-12">WhatsApp Notification</p>
                                            <div className="d-flex m-b-8" onClick={()=>handleToggleWhatsAppNorification("balance-due-reminder")}>
                                              {
                                                  branchInfo.whatsAppConfig.activeNotifications.indexOf("balance-due-reminder") == -1 ? (
                                                    <svg className="flex-item m-r-8" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#F1F1F1" stroke="#989898"/>
                                                  </svg>
                                                  ):(
                                                    <svg className="flex-item m-r-8" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                      <rect width="15" height="15" rx="4" fill="var(--darkBlue)"/>
                                                      <path d="M4 7.72727L6.33333 10L11 5" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                    </svg>
                                                  )
                                                }

                                                <p className="flex-item color-red font-weight-700" style={{lineHeight:"14px"}}>Balance due Reminder</p>
                                            </div>
                                            <div className="d-flex m-b-8" onClick={()=>handleToggleWhatsAppNorification("membership-sale")}>
                                              {
                                                  branchInfo.whatsAppConfig.activeNotifications.indexOf("membership-sale") == -1 ? (
                                                    <svg className="flex-item m-r-8" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#F1F1F1" stroke="#989898"/>
                                                  </svg>
                                                  ):(
                                                    <svg className="flex-item m-r-8" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                      <rect width="15" height="15" rx="4" fill="var(--darkBlue)"/>
                                                      <path d="M4 7.72727L6.33333 10L11 5" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                    </svg>
                                                  )
                                              }
                                              <p className="flex-item color-red font-weight-700" style={{lineHeight:"14px"}}>Membership Sale</p>
                                            </div>
                                            <div className="d-flex m-b-8" onClick={()=>handleToggleWhatsAppNorification("membership-expiry")}>
                                              {
                                                  branchInfo.whatsAppConfig.activeNotifications.indexOf("membership-expiry") == -1 ? (
                                                    <svg className="flex-item m-r-8" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#F1F1F1" stroke="#989898"/>
                                                  </svg>
                                                  ):(
                                                    <svg className="flex-item m-r-8" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                      <rect width="15" height="15" rx="4" fill="var(--darkBlue)"/>
                                                      <path d="M4 7.72727L6.33333 10L11 5" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                    </svg>
                                                  )
                                                }
                                              <p className="flex-item color-red font-weight-700" style={{lineHeight:"14px"}}>Membership Expiry</p>
                                            </div>
                                              <div className="d-flex m-b-8" onClick={()=>handleToggleWhatsAppNorification("enquiry")}>
                                              {
                                              branchInfo.whatsAppConfig.activeNotifications.indexOf("enquiry") == -1 ? (
                                                <svg className="flex-item m-r-8" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#F1F1F1" stroke="#989898"/>
                                              </svg>
                                              ):(
                                                <svg className="flex-item m-r-8" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <rect width="15" height="15" rx="4" fill="var(--darkBlue)"/>
                                                  <path d="M4 7.72727L6.33333 10L11 5" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                </svg>
                                              )
                                            }
                                              <p className="flex-item color-red font-weight-700" style={{lineHeight:"14px"}}>Enquiry</p>
                                            </div>
                                            <div className="d-flex m-b-8" onClick={()=>handleToggleWhatsAppNorification("birthday")}>
                                              {
                                              branchInfo.whatsAppConfig.activeNotifications.indexOf("birthday") == -1 ? (
                                                <svg className="flex-item m-r-8" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#F1F1F1" stroke="#989898"/>
                                              </svg>
                                              ):(
                                                <svg className="flex-item m-r-8" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <rect width="15" height="15" rx="4" fill="var(--darkBlue)"/>
                                                  <path d="M4 7.72727L6.33333 10L11 5" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                </svg>
                                              )
                                            }
                                              <p className="flex-item color-red font-weight-700" style={{lineHeight:"14px"}}>Birthday</p>
                                            </div>
                                              <div className="d-flex m-b-8" onClick={()=>handleToggleWhatsAppNorification("membership-renewal-reminder")}>
                                                {
                                                  branchInfo.whatsAppConfig.activeNotifications.indexOf("membership-renewal-reminder") == -1 ? (
                                                    <svg className="flex-item m-r-8" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#F1F1F1" stroke="#989898"/>
                                                  </svg>
                                                  ):(
                                                    <svg className="flex-item m-r-8" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                      <rect width="15" height="15" rx="4" fill="var(--darkBlue)"/>
                                                      <path d="M4 7.72727L6.33333 10L11 5" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                    </svg>
                                                  )
                                                }
                                              <p className="flex-item color-red font-weight-700" style={{lineHeight:"14px"}}>Renewal Reminder</p>
                                            </div>
                                          </div> */}

                                  </div>
                                </div>
                              </div>
                              <p className="fs-14 color-dark-blue font-weight-700 m-b-6">Biometric Configuration</p>
                              {
                                branchInfo.deviceList.length > 0 && branchInfo.deviceList.map((data, index) => {
                                  return(
                                    <div className="add-info-container w-full bg-white m-b-12" key={index}>
                                      <div className="d-flex-wrap space-between">
                                                 {/* <div onClick={toggleInputFields('device-id-'+index)} className={`${currentElementId == 'device-id-'+index || data.deviceID ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == 'device-id-'+index || data.deviceID ? "1px solid var(--darkBlue)" : "", width: "24%" }}>
                                                    <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'device-id-'+index || data.deviceID ? "10px" : "14px", color: currentElementId == 'device-id-'+index || data.deviceID ? "var(--darkBlue)" : "", transition: "180ms" }}>Device ID *</p>
                                                    <input id={'device-id-'+index} onChange={e => handleChange(e)} value={data.deviceID} placeholder="Enter Device ID" className={`${currentElementId == 'device-id-'+index || data.deviceID ? "active-input-field" : "inactive-input-field"}`} type="text" />
                                                  </div> */}

                                        <div onClick={toggleInputFields('serial-number-'+index)} className={`${currentElementId == 'serial-number-'+index || data.serialNumber ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == 'serial-number-'+index || data.serialNumber ? "1px solid var(--darkBlue)" : "", width: "49%" }}>
                                          <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'serial-number-'+index || data.serialNumber ? "10px" : "14px", color: currentElementId == 'serial-number-'+index || data.serialNumber ? "var(--darkBlue)" : "", transition: "180ms" }}>Serial Number/Host name *</p>
                                          <input id={'serial-number-'+index} onChange={e => handleChange(e)} value={data.serialNumber} placeholder="Enter Serial Number/Host name" className={`${currentElementId == 'serial-number-'+index || data.serialNumber ? "active-input-field" : "inactive-input-field"}`} type="text" />
                                        </div>
                                        <div onClick={toggleInputFields('ip-address-'+index)} className={`${currentElementId == 'ip-address-'+index || data.ipAddress ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == 'ip-address-'+index || data.ipAddress ? "1px solid var(--darkBlue)" : "", width: "24%" }}>
                                          <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === 'ip-address-'+index || data.ipAddress ? "10px" : "14px", color: currentElementId == 'ip-address-'+index || data.ipAddress ? "var(--darkBlue)" : "", transition: "180ms" }}>Ip address *</p>
                                          <input id={'ip-address-'+index} onChange={e => handleChange(e)} value={data.ipAddress} onBlur={onBlurAction} placeholder="Enter IP Address" className={`${currentElementId == 'ip-address-'+index || data.ipAddress ? "active-input-field" : "inactive-input-field"}`} type="text" />
                                        </div>
                                        <div onClick={toggleInputFields('deviceList-device-activities-'+index)} className={`${currentElementId == 'deviceList-device-activities-'+index || data.deviceActivity ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == 'deviceList-device-activities-'+index || data.deviceActivity ? "1px solid var(--darkBlue)" : "",  width: "24%"}}>
                                          <div className='d-flex w-full space-between'>
                                            <div className='flex-item'>
                                              <div className="flex-item d-flex">
                                                <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'deviceList-device-activities-'+index || data.deviceActivity ? "10px" : "", color: currentElementId == 'deviceList-device-activities-'+index || data.deviceActivity ? "var(--darkBlue)" : "", transition: "180ms" }}>Device Activities</p>
                                              </div>
                                              <input readOnly value={data.deviceActivity} type="text" className={`${currentElementId == 'deviceList-device-activities-'+index || data.deviceActivity ? "active-input-field" : "inactive-input-field"}`} placeholder="Select User Activity" />
                                            </div>
                                            <div className='input-field-arrow-dropdown' style={{ transform: isDropdownType == 'deviceList-device-activities-'+index ? "rotate(180deg)" : "", margin: "12px 8px 4px 0", transition: "180ms" }}>
                                              <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" strokeLinecap="round" />
                                              </svg>
                                            </div>
                                            {
                                              isDropdownType == 'deviceList-device-activities-'+index && (
                                                <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                                                  {
                                                    deviceActivities.map((data,idx) => {
                                                      return(
                                                        <div key={idx} onClick={()=>handleSelectActivity(data)} className="global-input-field-arrow-dropdown-item">
                                                          <p className="flex-item">{data}</p>
                                                        </div>
                                                      )
                                                    })
                                                  }
                                                </div>
                                              )
                                            }
                                          </div>
                                        </div>
                                        <div onClick={toggleInputFields('device-type-'+index)} className={`${currentElementId == 'device-type-'+index || data.deviceType ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: currentElementId == 'device-type-'+index || data.deviceType ? "1px solid var(--darkBlue)" : "",  width: "24%"}}>
                                          <div className='d-flex w-full space-between'>
                                            <div className='flex-item'>
                                              <div className="flex-item d-flex">
                                                <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'device-type-'+index || data.deviceType ? "10px" : "", color: currentElementId == 'device-type-'+index || data.deviceType ? "var(--darkBlue)" : "", transition: "180ms" }}>Device type *</p>
                                              </div>
                                              <input readOnly value={data.deviceType} type="text" className={`${currentElementId == 'device-type-'+index || data.deviceType ? "active-input-field" : "inactive-input-field"}`} placeholder="Select Device Type" />
                                            </div>
                                            <div className='input-field-arrow-dropdown' style={{ transform: isDropdownType == 'device-type-'+index ? "rotate(180deg)" : "", margin: "12px 8px 4px 0", transition: "180ms" }}>
                                              <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" strokeLinecap="round" />
                                              </svg>
                                            </div>
                                            {
                                              isDropdownType == 'device-type-'+index && (
                                                <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                                                  <div onClick={()=>handleSelectActivity("Dumbell")} className="global-input-field-arrow-dropdown-item">
                                                    <p className="flex-item">Dumbell</p>
                                                  </div>
                                                  <div onClick={()=>handleSelectActivity("Biometric")} className="global-input-field-arrow-dropdown-item">
                                                    <p className="flex-item">Biometric</p>
                                                  </div>
                                                </div>
                                              )
                                            }
                                          </div>
                                        </div>
                                        <div onClick={toggleInputFields('vendor-'+index)} className={`${currentElementId == 'vendor-'+index || data.vendor ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: currentElementId == 'vendor-'+index || data.vendor ? "1px solid var(--darkBlue)" : "",  width: "24%"}}>
                                          <div className='d-flex w-full space-between'>
                                            <div className='flex-item'>
                                              <div className="flex-item d-flex">
                                                <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'vendor-'+index || data.vendor ? "10px" : "", color: currentElementId == 'vendor-'+index || data.vendor ? "var(--darkBlue)" : "", transition: "180ms" }}>Vendor *</p>
                                              </div>
                                              <input readOnly value={data.vendor} type="text" className={`${currentElementId == 'vendor-'+index || data.vendor ? "active-input-field" : "inactive-input-field"}`} placeholder="Select vendor" />
                                            </div>
                                            <div className='input-field-arrow-dropdown' style={{ transform: isDropdownType == 'vendor-'+index ? "rotate(180deg)" : "", margin: "12px 8px 4px 0", transition: "180ms" }}>
                                              <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" strokeLinecap="round" />
                                              </svg>
                                            </div>
                                            {
                                              isDropdownType == 'vendor-'+index && (
                                                <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                                                  <div onClick={()=>handleDeviceVendor("ESSL",index)} className="global-input-field-arrow-dropdown-item">
                                                    <p className="flex-item">ESSL</p>
                                                  </div>
                                                  <div onClick={()=>handleDeviceVendor("BIOMAX",index)} className="global-input-field-arrow-dropdown-item">
                                                    <p className="flex-item">BIOMAX</p>
                                                  </div>
                                                </div>
                                              )
                                            }
                                          </div>
                                        </div>
                                        <div className={`member-global-input-field flex-item d-flex m-b-12`} style={{ width: "49%", visibility:'hidden' }}></div>
                                      </div>
                                      <div className="d-flex" style={{flexDirection:'row-reverse'}}>
                                        <div onClick={()=>removeBiometricDevice(index)} className="flex-item d-flex branch-header-action m-l-12 cursor-pointer" style={{width:"50px",height:"50px", background:"#FFE3E3"}}>
                                          <svg className="flex-item margin-auto svg-fill" width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.20202 19.1667C2.66068 19.1667 2.1999 18.9766 1.81968 18.5964C1.43946 18.2161 1.24935 17.7558 1.24935 17.2152V2.25002H0.0410156V1.04168H4.87435V0.111267H12.1243V1.04168H16.9577V2.25002H15.7493V17.2152C15.7493 17.7711 15.5633 18.2355 15.1911 18.6084C14.8189 18.9814 14.3541 19.1675 13.7967 19.1667H3.20202ZM14.541 2.25002H2.45768V17.2152C2.45768 17.4319 2.52736 17.6099 2.66672 17.7493C2.80608 17.8887 2.98452 17.9584 3.20202 17.9584H13.7979C13.9832 17.9584 14.1535 17.881 14.309 17.7264C14.4645 17.5717 14.5418 17.4009 14.541 17.214V2.25002ZM5.85068 15.5417H7.05902V4.66668H5.85068V15.5417ZM9.93968 15.5417H11.148V4.66668H9.93968V15.5417Z" fill="#E33A34"/>
                                          </svg>
                                        </div>
                                      </div>
                                    </div>
                                  )
                                })
                              }
                              <div onClick={()=>handleAddDeviceConfiguration()} className="d-flex">
                                <div className={`global-button-container d-flex flex-item m-t-12`} style={{borderRadius:"15px", height:"30px"}}>
                                  <p className="flex-item" style={{fontWeight:"600"}}>Add New Biometric Information</p>
                                </div>
                              </div>
                              {!accessKey && (
                                <div onClick={accessKeyLoading ? null : handleGenerateAccessKey} className="d-flex m-t-12">
                                  <div className={`global-button-container d-flex flex-item`} style={{borderRadius:"15px", height:"30px", width:"auto", padding:"0 16px"}}>
                                    <p className="flex-item" style={{fontWeight:"600"}}>
                                      {accessKeyLoading ? "Generating..." : "Generate Key"}
                                    </p>
                                  </div>
                                </div>
                              )}
                              {accessKey && (
                                <div style={{marginTop:"8px"}}>
                                  <div className="d-flex" style={{background:"#E8E8E8", borderRadius:"20px", padding:"6px 16px", width:"fit-content"}}>
                                    <p style={{margin:0, fontSize:"13px"}}>{accessKey}</p>
                                  </div>
                                  <div className="d-flex" style={{gap:"8px", marginTop:"6px"}}>
                                    <div onClick={handleCopyAccessKey} style={{background:"#E8E8E8", borderRadius:"12px", padding:"4px 12px", cursor:"pointer"}}>
                                      <p style={{margin:0, fontSize:"12px"}}>Copy</p>
                                    </div>
                                    <div onClick={handleDownloadAccessKey} style={{background:"#E8E8E8", borderRadius:"12px", padding:"4px 12px", cursor:"pointer"}}>
                                      <p style={{margin:0, fontSize:"12px"}}>Download</p>
                                    </div>
                                    <div onClick={handleDeleteAccessKey} style={{background:"#E8E8E8", borderRadius:"12px", padding:"4px 12px", cursor:"pointer"}}>
                                      <p style={{margin:0, fontSize:"12px"}}>Delete</p>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          )
                        }
                      </div>
                    )
                  }

                {
                  editType == "pem-file" && (
                    <div className="w-full m-t-16 no-scroll-bar" style={{overflowY:"auto", height:"85%"}}>
                      <div className="d-flex space-between">
                        <div className="pem-file-container bg-white d-flex flex-item space-between">
                          <p className="fs-16 font-weight-700 color-dark-blue flex-item">Member app pem</p>
                          <div className="flex-item d-flex" style={{width:"200px", height:"32px", border:"1px dashed #4d4d4d", backgroundColor:"#f5f5f5", borderRadius:"12px", textAlign:"center"}}>
                            <p className="margin-auto flex-item">Upload File</p>
                            <input className="flex-item cursor-pointer" type="file" style={{width:"200px", height:"40px", zIndex:"1"}} />
                          </div>
                        </div>
                        <div className="pem-file-container bg-white d-flex flex-item space-between">
                          <p className="fs-16 font-weight-700 color-dark-blue flex-item">Trainer app pem</p>
                          <div className="flex-item d-flex" style={{width:"200px", height:"32px", border:"1px dashed #4d4d4d", backgroundColor:"#f5f5f5", borderRadius:"12px", textAlign:"center"}}>
                            <p className="margin-auto flex-item">Upload File</p>
                            <input className="flex-item cursor-pointer" type="file" style={{width:"200px", height:"40px", zIndex:"1"}} />
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                }

                </div>

                <div
                  onClick={isButtonLock?null:props.type == "edit"?UpdateBranchInfo:CreateBranch}
                  className={`global-button-container ${isButtonLock?`global-button-container-inactive`:`global-button-container-active`} d-flex flex-item`}
                  style={window.innerWidth < 768
                    
                    ? {borderRadius:"25px", height:"40px", width:"calc(100% - 32px)", pointerEvents:isButtonLock?'none':'auto', margin:"0 16px 16px 16px", marginTop:"auto", flexShrink:0}
                    : {borderRadius:"20px", height:"40px", width:"100%", pointerEvents:isButtonLock?'none':'auto', marginTop:"12px"}
                  }
                >
                  <p className="flex-item" style={{fontWeight:"700"}}>{props.type == "edit" ? "Update" : "Create"}</p>
                </div>
              </div>
            ) : (

           
              <div className="d-flex-wrap w-full space-between no-scroll-bar" style={{maxHeight:"87%", overflowY:"auto"}}>
                <div className="branch-details-container bg-white" style={{width:"55%", height:"260px"}}>
                  <div className="details-header">
                    <p className="font-weight-700 color-dark-blue">Activities Offered and Amenities/Facilities</p>
                  </div>
                  <div className="details-body d-flex space-between no-scroll-bar" style={{height:"80%"}}>
                    <div style={{width:"48%"}}>
                      <p className="fs-12 m-b-6">Activities Offered</p>
                      {
                        branchInfo.offeredActivities.map(data=>{
                          return (
                          <div className="d-flex flex-item m-b-4">
                            <div className="details-bullet-point flex-item m-r-8" />
                            <p className="flex-item font-weight-700 color-grey-01">{data}</p>
                          </div>
                          )
                        })
                      }

                      {
                        branchInfo.amenities.length==0 && (
                          <p>No activities added.</p>
                        )
                      }
                      {/* <div className="d-flex flex-item m-b-4">
                        <div className="details-bullet-point flex-item m-r-8" />
                        <p className="flex-item font-weight-700 color-grey-01">Bollywood Dance</p>
                      </div> */}
                      {/* <div className="d-flex flex-item m-b-4">
                        <div className="details-bullet-point flex-item m-r-8" />
                        <p className="flex-item font-weight-700 color-grey-01">Functional Training</p>
                      </div>
                      <div className="d-flex flex-item m-b-4">
                        <div className="details-bullet-point flex-item m-r-8" />
                        <p className="flex-item font-weight-700 color-grey-01">Strength</p>
                      </div>
                      <div className="d-flex flex-item m-b-4">
                        <div className="details-bullet-point flex-item m-r-8" />
                        <p className="flex-item font-weight-700 color-grey-01">AEROBICS</p>
                      </div>
                      <div className="d-flex flex-item m-b-4">
                        <div className="details-bullet-point flex-item m-r-8" />
                        <p className="flex-item font-weight-700 color-grey-01">Personal Training</p>
                      </div>
                      <div className="d-flex flex-item m-b-4">
                        <div className="details-bullet-point flex-item m-r-8" />
                        <p className="flex-item font-weight-700 color-grey-01">Gym Workout</p>
                      </div> */}
                    </div>
                    <div style={{width:"48%"}}>
                      <p className="fs-12 m-b-6">Amenities / Facilities</p>
                        {
                        branchInfo.amenities.map(data=>{
                          return (
                          <div className="d-flex flex-item m-b-4">
                            <div className="details-bullet-point flex-item m-r-8" />
                            <p className="flex-item font-weight-700 color-grey-01">{data}</p>
                          </div>
                          )
                        })
                      }

                      {
                        branchInfo.amenities.length==0 && (
                          <p>No amenities added.</p>
                        )
                      }
                      {/* <div className="d-flex flex-item m-b-4">
                        <div className="details-bullet-point flex-item m-r-8" />
                        <p className="flex-item font-weight-700 color-grey-01">Other</p>
                      </div>
                      <div className="d-flex flex-item m-b-4">
                        <div className="details-bullet-point flex-item m-r-8" />
                        <p className="flex-item font-weight-700 color-grey-01">Music</p>
                      </div>
                      <div className="d-flex flex-item m-b-4">
                        <div className="details-bullet-point flex-item m-r-8" />
                        <p className="flex-item font-weight-700 color-grey-01">AC</p>
                      </div>
                      <div className="d-flex flex-item m-b-4">
                        <div className="details-bullet-point flex-item m-r-8" />
                        <p className="flex-item font-weight-700 color-grey-01">Wifi</p>
                      </div>
                      <div className="d-flex flex-item m-b-4">
                        <div className="details-bullet-point flex-item m-r-8" />
                        <p className="flex-item font-weight-700 color-grey-01">Group classes</p>
                      </div>
                      <div className="d-flex flex-item m-b-4">
                        <div className="details-bullet-point flex-item m-r-8" />
                        <p className="flex-item font-weight-700 color-grey-01">Locker</p>
                      </div> */}
                    </div>
                  </div>
                </div>
                <div className="branch-details-container bg-white" style={{width:"43%", height:"260px"}}>
                  <div className="details-header">
                    <p className="font-weight-700 color-dark-blue">Contact Details</p>
                  </div>
                  <div className="details-body d-flex space-between no-scroll-bar" style={{height:"80%"}}>
                    {
                      branchInfo.contactInfoList.map(data=>{
                        return (
                          <div className="w-full" style={{alignSelf:"flex-start"}}>
                            <div className="d-flex w-full space-between">
                              <div className="flex-item">
                                <p className="fs-12">Name</p>
                                <p className="flex-item font-weight-700 color-grey-01">{data.name}</p>
                              </div>
                              <div className="d-flex">
                                <div className="flex-item m-r-35">
                                  <p className="fs-12">Type</p>
                                  <p className="flex-item font-weight-700 color-grey-01">{data.type}</p>
                                </div>
                                {
                                data.primaryUser && (
                                    <div className="flex-item">
                                      <p className="fs-12 m-b-2">Primary</p>
                                      <svg className="m-l-12" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="8" cy="8" r="8" fill="#5D883C"/>
                                        <path d="M4 8.30769L6.52632 11L12 6" stroke="white" stroke-linecap="round"/>
                                      </svg>
                                    </div>
                                  )
                                }
                              </div>
                            </div>
                            <div className="flex-item m-t-20">
                              <p className="fs-12">Phone Numbers</p>
                              <p className="flex-item font-weight-700 color-grey-01">{data.contacts.join(",")}</p>
                            </div>
                            <div className="flex-item m-t-12">
                              <p className="fs-12">Emails</p>
                              <p className="flex-item font-weight-700 color-grey-01">{data.emailAddress.join(",")}</p>
                            </div>
                          </div>
                        )
                      })
                    }

                    {
                      branchInfo.contactInfoList.length==0 && (
                        <p>No contacts added.</p>
                      )
                    }

                    
              
                  </div>
                </div>
                <div className="branch-details-container bg-white m-t-12" style={{width:"100%", height:"196px"}}>
                  <div className="details-header">
                    <p className="font-weight-700 color-dark-blue">Gym Admins</p>
                  </div>
                  <div className="w-full d-flex space-between m-b-12" style={{padding:"12px 12px 0px 12px"}}>
                    <div className="flex-item tr-20">
                      <p className="fs-12">Name</p>
                    </div>
                    <div className="flex-item tr-15">
                      <p className="fs-12">Email</p>
                    </div>
                    <div className="flex-item tr-15">
                      <p className="fs-12">Phone</p>
                    </div>
                    <div className="flex-item tr-30">
                      <p className="fs-12">Employee Code</p>
                    </div>
                    <div className="flex-item tr-15">
                      <p className="fs-12">Role Names</p>
                    </div>
                    <div className="flex-item tr-10">
                      <p className="fs-12">Gender</p>
                    </div>
                  </div>
                  <div className="details-body no-scroll-bar" style={{height:"44%", paddingTop:"0"}}>
                    <div className="w-full" style={{alignSelf:"flex-start"}}>
                      {
                        gymAdmins.map(data => {
                          return(
                            <div className="w-full d-flex space-between m-b-12">
                              <div className="flex-item tr-20">
                                <p className="flex-item font-weight-700 color-grey-01">{data.name}</p>
                              </div>
                              <div className="flex-item tr-15">
                                <p className="flex-item font-weight-700 color-grey-01">{data.email?data.email:"--"}</p>
                              </div>
                              <div className="flex-item tr-15">
                                <p className="flex-item font-weight-700 color-grey-01">{data.phone?data.phone:"--"}</p>
                              </div>
                              <div className="flex-item tr-30">
                                <p className="flex-item font-weight-700 color-grey-01">{data.employee_code?data.employee_code:'--'}</p>
                              </div>
                              <div className="flex-item tr-15">
                                <p className="flex-item font-weight-700 color-grey-01">{getUserRole(data.role)}</p>
                              </div>
                              <div className="flex-item tr-10">
                                <p className="flex-item font-weight-700 color-grey-01" style={{textTransform:'capitalize'}}>{data.gender?data.gender:'--'}</p>
                              </div>
                            </div>
                          )
                        })
                      }


                      {
                        gymAdmins.length==0 && (
                          <p>No gym admins added.</p>
                        )
                      }

                    </div>
                  </div>
                </div>
                {
                  branchInfo.series.name && (
                    <div className="branch-details-container bg-white m-t-12" style={{width:"100%", height:"auto"}}>
                      <div className="details-header">
                        <p className="font-weight-700 color-dark-blue">Invoice Details</p>
                      </div>
                      <div className="details-body no-scroll-bar" style={{height:"80%"}}>
                        <div className="w-full d-flex space-between" style={{alignSelf:"flex-start"}}>
                          <div className="flex-item tr-40">
                            <p className="fs-12">Name</p>
                            <p className="flex-item font-weight-700 color-grey-01">{branchInfo.series.name}/ Date: {formatDateTime(branchInfo.series.date)}</p>
                          </div>
                          <div className="flex-item tr-20">
                            <p className="fs-12">Invoice Constant Character</p>
                            <p className="flex-item font-weight-700 color-grey-01">{branchInfo.series.invoiceConstant}</p>
                          </div>
                          <div className="flex-item tr-20">
                            <p className="fs-12">First Number</p>
                            <p className="flex-item font-weight-700 color-grey-01">{branchInfo.series.firstNumber}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                }
              
              </div>
            )
          }
      </div>
    </div>
    )
  }
}

export default ManageGym;